import '../css/main.less';

var {
  endpoint,
  finendpoint,
  cyberendpoint,
  financeplansendpointadmin,
  wfgplansendpoint,
  redirurl,
  PAYPAL_API_KEY,
  APPLE_MERCHANT_IDENTIFIER,
  APPLEPAY_URL,
  GIFT_CARD_URL,
  GATSBY_SYNCHRONY_DIGITAL_BUY_URL,
  GATSBY_CREDIT_MID,
  GATSBY_SYNCHRONY_SERVICE_URL,
  ANALYTICS_ID,
  GATSBY_FINGERPRINT_API_KEY,
  GATSBY_FPJS_PROXY_URL,
  GATSBY_FPJS_AGENT_DOWNLOAD_PATH,
  GATSBY_FPJS_BEHAVIOR_PATH,
  GATSBY_FPJS_GET_RESULT_PATH,
  GATSBY_PAYPAL_SERVICE_URL,
  IDENTITY_ENDPOINT
} = process.env;

const FINGERPRINT_LOCALSTORAGE_ID = 'FINGERPRINTIDLOCAL'
const FP_API_KEY = GATSBY_FINGERPRINT_API_KEY
const FPJS_AGENT_DOWNLOAD_PATH = GATSBY_FPJS_AGENT_DOWNLOAD_PATH
const FPJS_BEHAVIOR_PATH = GATSBY_FPJS_BEHAVIOR_PATH
const FPJS_GET_RESULT_PATH = GATSBY_FPJS_GET_RESULT_PATH
const FPJS_PROXY_URL = GATSBY_FPJS_PROXY_URL
const product_file = 'https://products.roomstogo.com/';

const getFingerprintId = () => localStorage.getItem(FINGERPRINT_LOCALSTORAGE_ID);


//const allowPayOnlineStores = [970, 980, 911, 1091, 2911, 913, 1094, 1694, 2913, 902, 1092, 917, 103]; /*Removed - only using flag now //Only display pay online page for these stores*/
const finNOTallowedStores = [
  911, 1091, 2911, 913, 1094, 1694, 2913, 902, 1092, 917,
]; /*other stores can still pay, but can't finance.*/

const onlineStores = ['960','970','980','1060','1070','1080','2960','2970','2980','3960','3970','3980'];

var financeData = {};
var financeAcctNo = "";
var availableFinBalance = 0;
var ccAuthAmt = 0;
var ccPaymentInfo = {};
var finAuthAmt = 0;
var ppAuthAmt = 0;
var ppOrderData = {};

var appleAuthAmt = 0;
var appleOrderData = {};
var session = null;

var genesisData = {};
var genesisAcctNo = "";
var availableGenesisBalance = 0;
var genesisAuthAmt = 0;

var giftCardData = {};
var giftCardAcctNo = "";
var availableGiftCardBalance = 0;
var giftCardAuthAmt = 0;

var longTermFinanceAmt = 0;
var downPaymentAmt = 0;
var longTermPlans = {};
var selectedPlan = {};

var wfgFinanceData = {};
var wfgFinanceAcctNo = "";
var wfgAvailableFinBalance = 0;
var wfgFinAuthAmt = 0;
var wfgPlans = {};
var wfgSelectedPlan = {};

var rtgOrderData = null;

var digiBuyState = {
  clicked: false,
  unavailableButton: true,
  enableButton: false,
  clientToken: null,
  financeCode: "600",
  currentPlan: null,
  currentTotal: 0,
  processInd: 1,
  payerInfo: {
    payer: {
      billingDifferent: false,
    },
  },
  clientFirstName: "",
  clientLastName: "",
  approvedApply: false,
  showAlertModal: false,
  closeAlertModal: true,
  textAlertModal: "",
  accountNumber: null,
  TokenId: null,
};
var useExistingDeposit = false;
var mattressUpsell = false;
var orderUpsell = false;
var upsellAnalytics = {};
var upsellAnalyticsProds = [];
var curpay = 0.0;

const identifyFingerprint = async() => {
  const segmentUser = typeof window?.analytics?.user === 'function' && window.analytics?.user()
  const email = rtgOrderData?.EmailAddress || segmentUser?.traits?.()?.email
  const zipcode = segmentUser?.traits?.()?.zipcode || rtgOrderData?.DeliveryAddress?.Zip;
  const user_id = urlParam('userId');

  if (!segmentUser?.traits?.()?.fingerprint_id) {
    try {
      const fingerprint_id = getFingerprintId()
      let userId = user_id || segmentUser?.id?.() || fingerprint_id
      const traitsData = {
        email,
        zipcode,
        fingerprint_id,
      }

      //window.analytics?.identify(userId, traitsData, {}, identifyUserCallback)
      if(!user_id || user_id == '')
        userId = await getUserIdentity(email, fingerprint_id, zipcode);

      localStorage.setItem("ajs_user_id", userId);

      dataLayer.push({
        event: "segment_identify",
        userId,
        ...traitsData,
      });

      dataLayer.push({
        event: "segment_loaded",
        segment_loaded: true,
        pathname: window.location.pathname,
        segmentId: userId,
        fingerprint_id,
      });



    } catch (e) {
      throw new Error({ e, message: 'Error identifying Segment user. (fingerprint_id)' })
    }
  } else {
    let fingerprint_id = segmentUser?.traits?.()?.fingerprint_id;
    let userId = fingerprint_id;
    //identifyUserCallback()
    dataLayer.push({
      event: "segment_loaded",
      segment_loaded: true,
      pathname: window.location.pathname,
      segmentId: userId,
      fingerprint_id,
    });
    if(!fingerprint_id || fingerprint_id == '')
      userId = await getUserIdentity(email, fingerprint_id, zipcode);
    localStorage.setItem("ajs_user_id", userId);
  }
}
const identifyUserCallback = () => {}

const initFingerPrint = async () => {
  try {
    let fingerprintId = getFingerprintId()
    console.log(fingerprintId)
    if (isEmpty(fingerprintId)) {
      const baseUrl = `${FPJS_PROXY_URL}/${FPJS_BEHAVIOR_PATH}`
      const fingerprintOptions = {
        endpoint: [`${baseUrl}/${FPJS_GET_RESULT_PATH}?region=us`, FingerprintJS.defaultEndpoint],
        apiKey: FP_API_KEY,
        scriptUrlPattern: [
          `${baseUrl}/${FPJS_AGENT_DOWNLOAD_PATH}?apiKey=${FP_API_KEY}&version=3&loaderVersion=3.8.3`,
          FingerprintJS.defaultScriptUrlPattern,
        ],
      }
      const fingerPrint = await FingerprintJS.load(fingerprintOptions)
      const result = await fingerPrint.get()
      const { visitorId } = result
      fingerprintId = visitorId
      localStorage.setItem(FINGERPRINT_LOCALSTORAGE_ID, fingerprintId)
    }
    if(window?.analytics)
      identifyFingerprint(fingerprintId)

  } catch (error) {
    console.log(`Loading Fingerprint failed. ${error.message}`)
  }
}

const getUserIdentity = async (email, fingerprint_id, zip) => {
  let body = {
    email: email,
    fingerprintId: fingerprint_id,
    attributes: {
        zipcode: zip
    }
  }
  let identityRes = await fetch(`${IDENTITY_ENDPOINT}/user`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });
  let userData = await identityRes.json();
  let userId = userData?.userId;
  console.log(userData);

  return userId;
};

function isEmpty(value){
  var isEmptyObject = function(a) {
    if (typeof a.length === 'undefined') { // it's an Object, not an Array
      var hasNonempty = Object.keys(a).some(function nonEmpty(element){
        return !isEmpty(a[element]);
      });
      return hasNonempty ? false : isEmptyObject(Object.keys(a));
    }

    return !a.some(function nonEmpty(element) { // check if array is really not empty as JS thinks
      return !isEmpty(element); // at least one element should be non-empty
    });
  };
  return (
    value == false
    || typeof value === 'undefined'
    || value == null
    || (typeof value === 'object' && isEmptyObject(value))
  );
}

const formatZip = (zip) => {
  if (zip.length > 5) {
    return zip.slice(0, 5) + "-" + zip.slice(5);
  } else {
    return zip.slice(0, 5);
  }
};

const urlParam = function (name) {
  var results = new RegExp("[?&]" + name + "=([^&#]*)").exec(
    window.location.href
  );
  if (results == null) {
    return null;
  } else {
    return decodeURI(results[1]) || 0;
  }
};

const fetchClientToken = async () => {
  let tokRes = await fetch(`${GATSBY_SYNCHRONY_SERVICE_URL}/token`);
  let tokData = await tokRes.json();
  console.log(tokData);
  let clientToken = tokData.clientToken;
  digiBuyState.clientToken = clientToken;
  updateDigibuyForm(rtgOrderData);
};

const fetchClientTokenStatus = async (body) => {
  let tokRes = await fetch(`${GATSBY_SYNCHRONY_SERVICE_URL}/tokenStatus`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });
  let tokData = await tokRes.json();
  console.log(tokData);
  return tokData;
};

function addSnippet() {
	var script = document.createElement("script");
	script.text = `!function(){var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on","addSourceMiddleware","addIntegrationMiddleware","setAnonymousId","addDestinationMiddleware"];analytics.factory=function(e){return function(){var t=Array.prototype.slice.call(arguments);t.unshift(e);analytics.push(t);return analytics}};for(var e=0;e<analytics.methods.length;e++){var key=analytics.methods[e];analytics[key]=analytics.factory(key)}analytics.load=function(key,e){var t=document.createElement("script");t.type="text/javascript";t.async=!0;t.src="https://cdn.segment.com/analytics.js/v1/${ANALYTICS_ID}/analytics.min.js";var n=document.getElementsByTagName("script")[0];n.parentNode.insertBefore(t,n);analytics._loadOptions=e};analytics._writeKey="${ANALYTICS_ID}";;analytics.SNIPPET_VERSION="4.15.3";
	analytics.load("${ANALYTICS_ID}");
	analytics.page();
	}}();`;
	document.head.appendChild(script);
}

async function addPaypal() {
	var script = document.createElement("script");
	script.src = `https://www.paypal.com/sdk/js?client-id=${PAYPAL_API_KEY}&locale=en_US&intent=authorize&commit=false&disable-funding=credit`;
	document.head.appendChild(script);
}

async function getProductInfo (sku) {
	try{
		let prod_info =  await fetch(`${product_file}${sku.toUpperCase()}.json`);
		return await prod_info.json();
	}
	catch(e){
		return false;
	}
}

async function getFinanceProviders (orderKey) {
  try{
		let providersData =  await fetch(`${endpoint}/ordermod/finance/options?orderKey=${orderKey}`);
		return await providersData.json();
	}
	catch(e){
		return false;
	}
}

function fixOrderKey(orderKey) {
	if(orderKey && orderKey.indexOf('?') !==-1){
		orderKey = orderKey.split('?')[0];
	}
	return orderKey;
}

document.addEventListener("DOMContentLoaded", async (_) => {
  await addPaypal();
  addSnippet();
  var script = document.createElement("script");
  script.onload = async function (e) {
    //do stuff with the script

    await fetchClientToken();
  };
  script.src = GATSBY_SYNCHRONY_DIGITAL_BUY_URL;

  document.head.appendChild(script);

  const orderId = urlParam("orderId");
  const zipcode = urlParam("zipcode");
  const division = urlParam("division");
  const orderKey = fixOrderKey(urlParam("orderKey"));

  if (!applePayEnabled()){
    console.log('apple pay NOT enabled');
    document.querySelector(".options .apple-pay").classList.add("hide");
    document.querySelector(".options .apple").classList.add("hide");
  }


  if (orderKey) {
    let action = "/ordersHistoryByKey";
    let orderRes = await fetch(`${endpoint}${action}?orderKey=${orderKey}`);
    let orderData = await orderRes.json();
    let escAddData = getCookie("escAddData") ? JSON.parse(getCookie("escAddData")): '';
    let mattressAddData = getCookie("mattressAddData") ? JSON.parse(getCookie("mattressAddData")): '';
    let orderUpsellData = getCookie("orderUpsellData") ? JSON.parse(getCookie("orderUpsellData")): '';

    if (orderRes.status !== 200) {
      showErrors(orderData.error.message);
      return false;
    }

    if ((escAddData?.orderKey && escAddData?.orderKey == orderKey) || (mattressAddData?.orderKey && mattressAddData?.orderKey == orderKey) || (orderUpsellData?.orderKey && orderUpsellData?.orderKey == orderKey)){
      if(parseFloat(orderData.Balance) > 0){
        showErrors("Pay Online is not available for this Order");
        return false;
      }
    }
    else if (
      (!orderData.showPayonline && !orderData.upgradeDelivery) ||
      (parseFloat(getTotalBalance(orderData)) <= 0.1 &&
        !orderData.upgradeDelivery)
    ) {
      /* || !allowPayOnlineStores.includes(parseInt(orderData.StoreNumber))){*/
      showErrors("Pay Online is not available for this Order");
      return false;
    }

    await updateDigibuyForm(orderData);
    rtgOrderData = orderData;
    initFingerPrint();


    if (orderData.upgradeDelivery === true) {
      action = "/premiumDelivery";
      let phoneNumber = orderData.Customer.PhoneNumber.replace("/", "")
        .replace("-", "")
        .replace("NPI", "");
      let pDRes = await fetch(
        `${endpoint}${action}?orderId=${orderData.OrderNumber}&zipcode=${orderData.DeliveryAddress.Zip}&phoneNumber=${phoneNumber}`
      );
      let pDData = await pDRes.json();
      orderData.upgradeInfo = pDData.upgradeCharge;
    }
    console.log(mattressAddData)
    //GET TAX
    if((escAddData?.orderKey && escAddData?.lineItems?.length && escAddData?.orderKey == orderData.orderKey) || (mattressAddData?.orderKey && mattressAddData?.skus.length && mattressAddData?.orderKey == orderData.orderKey)){
      let skus = [];
      let warrantyBalance = 0;
      let taxObj = {};
      if(escAddData?.lineItems && escAddData?.lineItems?.length  && escAddData?.orderKey == orderData.orderKey){
          let lineItems = JSON.parse(JSON.stringify(escAddData?.lineItems));
          console.log(lineItems)
          skus = lineItems;
          warrantyBalance = 0;
          skus.map(item => {
            warrantyBalance += parseFloat(item.unitPrice);
            delete item.provider;
            //delete item.quantity;
            //delete item.deliveryType;
            //delete item.warrantyPrice;
            delete item.unitPrice;
            delete item.plan;
            delete item.lineNumber;
            delete item.title;

          });
          console.log(skus)
          taxObj = {
            orderKey,
            lineItems: skus.filter(p => p?.warrantyPrice > 0 && p.sku.indexOf('P') == -1)
          }
      }
      if(mattressAddData?.skus && mattressAddData?.skus.length && mattressAddData?.orderKey == orderData.orderKey){
          const lineItems = JSON.parse(JSON.stringify(mattressAddData?.skus));
          console.log(lineItems)
          mattressUpsell = true;
          let financeProviders = await getFinanceProviders(orderKey);

          orderData.financeProvider = financeProviders.financeProviders;
          orderData.addonFinanceEligible = financeProviders.addonFinanceEligible;
          if(financeProviders.addonFinanceEligible)
            orderData.financePaymentEligible = true;
          skus = [...lineItems]; //JSON.parse(JSON.stringify(lineItems));
          //skus.filter(p => p?.unitPrice > 0);
          warrantyBalance = 0;
          await Promise.all(skus.map(async item => {
            warrantyBalance += parseFloat(item.unitPrice);
            item.sku = item.skuId
            delete item.skuId;
            delete item.provider;
            //delete item.quantity;
            //delete item.deliveryType;
            //delete item.warrantyPrice;
            //delete item.unitPrice;
            delete item.plan;
            delete item.lineNumber;
            delete item.title;
            if(item.sku.indexOf('P') != -1){ console.log('package')
              let prodItem = await getProductInfo(item.sku);
              console.log(prodItem)
              let packageskus = prodItem?.package_skus[orderData?.Division];
              await Promise.all(packageskus.map(child => {
                skus.push({
                  sku: child.sku,
                  quantity: parseInt(child.quantity),
                  unitPrice: parseFloat(child.price),
                  deliveryType: item.deliveryType
                })
              }))

            }

          }));
          taxObj = {
            orderKey,
            lineItems: skus.filter(p => p?.unitPrice > 0 && p.sku.indexOf('P') == -1)
          }
      }


      let action = "/ordermod/tax";
        let taxRes = await fetch(`${endpoint}${action}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(taxObj),
        });
        let taxData = await taxRes.json();
        console.log(taxData)
        console.log(warrantyBalance)
        orderData.newTax = parseFloat(taxData?.tax);
        orderData.originalBalance = orderData.Balance;
        orderData.Balance = parseFloat(taxData?.tax) + parseFloat(warrantyBalance) + orderData.Balance;
        orderData.mattressBalance = parseFloat(taxData?.tax) + parseFloat(warrantyBalance);
    }


    let upsellRevenue = 0;
    let upsellTax = 0;
    if(orderUpsellData?.skus && orderUpsellData?.skus.length && orderUpsellData?.orderKey == orderData.orderKey){
      orderUpsell = true;
      orderData.originalBalance = orderData.Balance;
      let upsellBalance = 0;
      orderUpsellData.skus.map(item => {
        upsellBalance += parseFloat(item.amount * item.quantity);
        upsellRevenue += parseFloat(item.difference * item.quantity);
        upsellTax += parseFloat(item.tax_difference * item.quantity);
        upsellAnalyticsProds.push({
          title: item.title,
          sku: item.skuId,
          price: item.price,
          quantity: item.quantity
        })
        delete item.oldsku;
        delete item.price;
        delete item.amount;
        delete item.skuId;
        delete item.deliveryType;
        delete item.title;
        delete item.difference;
        delete item.tax_difference;
        delete item.warrantyPriceDifference;
      });
      orderData.Balance = upsellBalance.toFixed(2);

      upsellAnalytics.revenue = upsellRevenue;
      upsellAnalytics.tax = upsellTax;

      dataLayer.push({
				event: "ee_checkout",
        ecommerce: {
            checkout: {
                products: upsellAnalyticsProds
            }
        },
        payonline_origin: "post_order_upsell",
        cart_type: "payonline"
			});
    }
    console.log(upsellAnalyticsProds)
    console.log(upsellAnalytics)


    await buildInterface(orderData);
    console.log(document.referrer);
    let ref = getCookie("referrer");
    console.log(ref);
    let origin =
      document.referrer.indexOf("ordermod") != -1
        ? "order_modification"
        : document.referrer.indexOf("escplan") != -1
        ? "esc_addon"
        : document.referrer;
    if (ref != "") origin = ref;

    let items = orderData.LineItems.LineItem
      ? orderData.LineItems.LineItem
      : orderData.LineItems;

    let eventObject = {
      event: "ee_checkout",
      payonline_origin: origin,
      ecommerce: {
        checkout: {
          products: items,
        },
      },
    };

    if((escAddData?.orderKey && escAddData?.lineItems?.length && escAddData?.orderKey == orderData.orderKey) || (mattressAddData?.orderKey && mattressAddData?.skus.length && mattressAddData?.orderKey == orderData.orderKey)){
      let revenue = 0;
      if(mattressAddData?.orderKey && mattressAddData?.skus.length && mattressAddData?.orderKey == orderData.orderKey){
        mattressAddData = getCookie("mattressAddData") ? JSON.parse(getCookie("mattressAddData")): '';
        await Promise.all(mattressAddData?.skus.map(async item => {
          revenue += parseFloat(item.unitPrice);
          item.sku = item.skuId
          if(item.title)
            item.name = item.title;
          if(item.deliveryType)
            item.delivery_type = item.deliveryType;
          item.price = item.unitPrice;
          delete item.skuId;
          delete item.provider;
          delete item.plan;
          delete item.lineNumber;
          delete item.title;
          delete item.deliveryType;

        }));
      }
      else {
        escAddData?.lineItems.map(item => {
          revenue += parseFloat(item.unitPrice);
        });
      }
      let addData = escAddData?.lineItems?.length ? escAddData?.lineItems : mattressAddData?.skus;

      let eventObject = {
        event: "ee_checkout",
        payonline_origin: origin,
        ecommerce: {
          checkout: {
            products: addData,
          },
        },
      };
      console.log(eventObject)
      if(origin == "esc_addon"){
        eventObject.payonline_esc = orderData.Balance;
      }
      dataLayer.push(eventObject);
    }



    dataLayer.push({
      event: "ee_checkout_option",
      ecommerce: {
        checkout_option: {
          step: 3,
        },
      },
    });

    document.addEventListener("click", async function (e) {
      console.log(e.target.id);
      if (e.target.id == "upgrade") {
        //handle change for upgrade delivery
        dataLayer.push({
          event: "changeDelivery",
          orderStatus: {
            OrderNumber: orderData.OrderNumber,
            Status: orderData.orderStatus,
            DeliveryDate: orderData.DeliveryDate,
            OrderDate: orderData.OrderDate,
            Balance: orderData.Balance,
            OrderTotal: orderData.OrderTotal,
            Division: orderData.Division,
            premiumDelivery: orderData.upgradeDelivery,
            premiumDeliveryCharge: orderData?.upgradeInfo,
            PaymentType: orderData.PaymentType,
          },
        });
        clearFinancing(orderData);
        clearCybersource(orderData);
        clearGenesis(orderData);
        clearGiftCard(orderData);
        pay_toggle("cc");
        updateAmounts(orderData);
      }
      if (e.target.name == "pay-amount") {
        clearFinancing(orderData);
        clearCybersource(orderData);
        clearGenesis(orderData);
        clearGiftCard(orderData);
        pay_toggle("cc");
        updateAmounts(orderData);
        /*dataLayer.push({
					'event': 'ee_checkout_option',
					'ecommerce': {
					   checkout_option: {
							step: 3
						}
					}
				});*/
      }
      if (e.target.name == "cc") {
        if (
          availableFinBalance &&
          finAuthAmt > 0 &&
          availableFinBalance >= getTotalBalance(orderData)
        ) {
          document
            .querySelector(".options .tooltip.fin")
            .classList.remove("hide");
          return false;
        }
        if (document.getElementById("flexresponse").value !== "") {
          document
            .querySelector(".options .tooltip.credit")
            .classList.remove("hide");
          return false;
        }

        if (document.getElementById("paypal_response").value !== "") {
          document
            .querySelector(".options .tooltip.paypal")
            .classList.remove("hide");
          return false;
        }
        // if(genesisAuthAmt > 0){
        // 	document.querySelector('.options .tooltip.credit').classList.remove('hide');
        // 	return false;
        // }

        pay_toggle("cc");
        scrollToReview();
      }

      if (e.target.name == "rtgcc" && !orderData?.addonFinanceEligible /*!orderData?.FinDeposits?.Deposit?.length*/) {
        if (
          availableFinBalance &&
          finAuthAmt > 0 &&
          availableFinBalance >= getTotalBalance(orderData)
        ) {
          document
            .querySelector(".options .tooltip.fin")
            .classList.remove("hide");
          return false;
        }
        if (document.getElementById("flexresponse").value !== "") {
          document
            .querySelector(".options .tooltip.credit")
            .classList.remove("hide");
          return false;
        }
        if (genesisAuthAmt > 0) {
          document
            .querySelector(".options .tooltip.credit")
            .classList.remove("hide");
          return false;
        }
        if (document.getElementById("paypal_response").value !== "") {
          document
            .querySelector(".options .tooltip.paypal")
            .classList.remove("hide");
          return false;
        }
        pay_toggle("rtgcc");
        //document.querySelector(".col.other").classList.add('hide');
        //document.querySelector(".other-amt").disabled = true;
        //document.querySelector(".other-amt").value = 0;
        //document.querySelector('input[name="pay-amount"][value="balance"]').checked = true;

        await updateDigibuyForm(rtgOrderData);
        showFinancePlans(rtgOrderData);

        //openModal('dbuyform3');
      }
      if (e.target.name == "rtgcc" && orderData?.financePaymentEligible && orderData?.addonFinanceEligible) {
        if(!checkMinPayment())
          return true;
        //financeAcctNo = document.querySelector('input[name="account_number_confirm"]')?.value?.toString();
        //financeData = await getFinanceInfo(financeAcctNo, zipcode, orderData);
         // if (parseInt(financeData.statusCode) == 200) {
           // availableFinBalance = parseFloat(financeData.availableCredit).toFixed(2);
           pay_toggle("rtgcc");
            document.querySelector(".modal").classList.remove("hide");
            document.querySelector(".modal-holder-deposit").classList.remove("hide");
            document.querySelector(".terms-modal").classList.add("hide");
            document.querySelector(".promo-modal").classList.add("hide");
            document.querySelector(".modal-holder").classList.add("hide");
            document.getElementById("submit-deposit-btn").setAttribute("disabled", true);
            document.getElementById("submit-deposit-btn").classList.add("hide");
            document.querySelector(".modal-holder-deposit .plan-info").innerHTML = `<div class="plan-name"><label>Plan Name: </label>${orderData?.FinancePlan}</div><div class="last-four"><label>Last 4 Digits: </label>xxxxxxxxxxxx${orderData?.financeAccountNumber?.slice(-4)}</div>`;
        //  }
      }
      if (e.target.name == "wfgcc") { console.log('wells fargo')
        pay_toggle("wfgcc");
        await showWfgFinancePlans(rtgOrderData);

        document.querySelector(".modal").classList.remove("hide");
        document.querySelector(".modal-holder-wfg").classList.remove("hide");
        document.querySelector('.modal-holder-wfg .step-1').classList.remove('hide');
        document.querySelector('.modal-holder-wfg .step-2').classList.add('hide');
        document.querySelector(".terms-modal").classList.add("hide");
        document.querySelector(".promo-modal").classList.add("hide");
        document.querySelector(".modal-holder").classList.add("hide");
        document.getElementById("submit-deposit-btn").setAttribute("disabled", true);
        document.getElementById("submit-deposit-btn").classList.add("hide");
        document.querySelector('.modal-holder-wfg .step-1 .error').innerHTML = '';
        scrollToTop();
      }
      if(e.target.id == "wfg-continue-btn"){
        if(e.target.dataset.step == "1"){
          getWfgFinAccountData();
        }
        if(e.target.dataset.step == "2"){
          //getWfgFinAccountData();
          let totalBalance = getTotalBalance(orderData);

          let remainingBalance = parseFloat(totalBalance - wfgAvailableFinBalance);
          remainingBalance = remainingBalance < 0 ? 0 : remainingBalance;
          wfgFinAuthAmt = totalBalance - remainingBalance;
          let finMesssage = '';
          if (
            longTermFinanceAmt &&
            downPaymentAmt > 0 &&
            wfgSelectedPlan.downPaymentRequired
          ) {
            remainingBalance = wfgFinAuthAmt - downPaymentAmt;
            wfgFinAuthAmt = remainingBalance;
            finMesssage =

                `<div class="financing-applied">
                  <div class="fin-content">
                    <img src="images/green-check.svg" /><p class="fin-applied">Financing Applied $${parseFloat(remainingBalance).toFixed(2)}<span class="finance-plan">${wfgSelectedPlan.siteFriendlyLabel}</span></p>
                  </div>
                  <button class="remove-financing">Remove</button>
                </div>
                <div class="remaining-balance">Remaining Balance Due: $${parseFloat(downPaymentAmt).toFixed(2)}<span class="pay-note">Pay remaining balance with credit/debit card</span></div>`;
            pay_toggle("cc");
            loadPayPalButton(orderData);
            loadApplePay(orderData);
            scrollToReview();
            document.querySelector(
              ".review-payment .line-item.wfg-finance-applied .amt"
            ).innerText = "$" + parseFloat(remainingBalance).toFixed(2);
            document
              .querySelector(".review-payment .line-item.wfg-finance-applied")
              .classList.remove("hide");
          }
          else {
          /*let remainingBalance = parseFloat(totalBalance - wfgAvailableFinBalance);
          remainingBalance = remainingBalance < 0 ? 0 : remainingBalance;
          wfgFinAuthAmt = totalBalance - remainingBalance;*/
          console.log(wfgSelectedPlan)

          finMesssage = `<div class="wfg-financing-applied">
            <div class="fin-content">
              <img src="images/green-check.svg" /><p class="fin-applied">Wells Fargo Financing Applied $${parseFloat(wfgFinAuthAmt).toFixed(2)}<span class="finance-plan">${wfgSelectedPlan.siteFriendlyLabel}</span></p>
            </div>
            <button class="wfg-remove-financing">Remove</button>
          </div>`;
          if(remainingBalance > 0){
            finMesssage+= `<div class="remaining-balance">Remaining Balance Due: $${parseFloat(remainingBalance).toFixed(2)}<span class="pay-note">Pay remaining balance with credit/debit card</span></div>`;
            loadPayPalButton(orderData);
            //loadApplePay(orderData);
            scrollToReview();
          }
          else {
            removeCC();
            scrollToReview();
            document.querySelector(".review-payment .row").classList.remove("hide");
          }
        }
          document.querySelector(".review-payment .line-item.wfg-finance-applied .amt").innerText = "$" + parseFloat(wfgFinAuthAmt).toFixed(2);
          document.querySelector(".review-payment .line-item.wfg-finance-applied").classList.remove('hide');
          document.querySelector(".modal").classList.add("hide");
          document.querySelector(".modal-holder-wfg").classList.add("hide");
          document
          .querySelector(".balance-applied").innerHTML = '';
          document
          .querySelector(".balance-applied")
          .insertAdjacentHTML(
            "afterbegin",
            finMesssage
          );

          //hide other payment options
          document.querySelector(".other-amt").disabled = true;
          document.querySelector('.options .rtgcc').classList.add('hide');
          document.querySelector('.options .wfgcc').classList.add('hide');
          document.querySelector('.options .genesis-cc').classList.add('hide')
        }
      }
      if(e.target.id == "synchrony-deposit-agree-btn"){
        document.querySelector("#synchrony-deposit-cancel-btn").classList.add("hide");
        document.querySelector("#synchrony-deposit-agree-btn").classList.add("hide");
        document.querySelector(".deposit-disclosures .promo-deposit-disclosures").classList.add("hide");
        document.querySelector(".review-payment .row").classList.remove("hide");
        scrollToReview();
      }
      if(e.target.id == "submit-deposit-btn"){
        let accountNumber = document.querySelector('input[name="account_number_confirm"]')?.value?.toString();
        let totalBalance = getTotalBalance(orderData);
        /*financeData = await getFinanceInfo(accountNumber, zipcode, orderData);

        if (parseInt(financeData.statusCode) == 200) {
          console.log(financeData)
          availableFinBalance = parseFloat(financeData.availableCredit).toFixed(2);
        }*/
        let remainingBalance = parseFloat(totalBalance - availableFinBalance);
        remainingBalance = remainingBalance < 0 ? 0 : remainingBalance;
        finAuthAmt = totalBalance - remainingBalance;
        //pay_toggle("cc");
        let finMesssage = `<p class="">Financing Applied $${parseFloat(finAuthAmt).toFixed(2)}</p>`;
        if(remainingBalance > 0){
          finMesssage+= `<button id="add-cc-btn" class="add-cc-btn">Click Here to Pay remaining $${parseFloat(
                remainingBalance
              ).toFixed(2)} with Credit Card</button>`


        }
        else {

          removeCC();

          /*
          scrollToReview();
          document.querySelector(".review-payment .row").classList.remove("hide");
          */
        }
        /*added show disclosures*/
              document.querySelector(".deposit-disclosures .plan-name").innerHTML = "";
              //document.querySelector(".terms-conditions").classList.remove("hide");

              document.querySelector("#synchrony-deposit-cancel-btn").classList.remove("hide");
              document.querySelector("#synchrony-deposit-agree-btn").classList.remove("hide");
              document.querySelector(".deposit-disclosures .plan-name").classList.remove("hide");
              document.querySelector(".loading-icon").classList.add("hide");
              document.querySelector(".available-balance").innerHTML = "";
              document
                .querySelector(".available-balance")
                .insertAdjacentHTML(
                  "afterbegin",
                  `$${parseFloat(financeData.availableCredit).toFixed(2)}`
                );
              document.querySelector(".deposit-disclosures .plan-name").innerHTML =
                financeData.siteFriendlyLabel +
                `<br/><a id="promo-details-link">See full details here</a>`;
              document.querySelector(".terms-modal").innerHTML =
                financeData?.termsAndConditions?.childMarkdownRemark?.html;
              document.querySelector(".modal-holder-promo .content").innerHTML =
                financeData?.promoMessage?.childMarkdownRemark?.html;
              document.querySelector(".promo-info .marketing").innerHTML =
                financeData?.marketingMessage?.markdown?.childMarkdownRemark.html;

              document.querySelector(".promo-deposit-disclosures .promo").innerHTML =
                financeData?.disclosureData?.promoDisclosure; //financeData.promoMessage.childMarkdownRemark.html;
              document.querySelector(".deposit-disclosures .promo-deposit-disclosures").classList.remove("hide");


        /*end added show disclosures*/

        document.querySelector(".review-payment .line-item.finance-applied .amt").innerText = "$" + parseFloat(finAuthAmt).toFixed(2);
        document.querySelector(".review-payment .line-item.finance-applied").classList.remove('hide');
        document.querySelector(".modal").classList.add("hide");
        document.querySelector(".modal-holder-deposit").classList.add("hide");
        useExistingDeposit = true;
        document.querySelector("#synchrony-remove-btn").classList.remove("hide");
        document.querySelector(".rtgcc-box").classList.remove("hide");
        document.querySelector(".balance-applied").innerHTML = '';
        document
        .querySelector(".balance-applied")
        .insertAdjacentHTML(
          "afterbegin",
          finMesssage
        );

        document.querySelector(".other-amt").disabled = true;
        scrollToSection('.deposit-disclosures .promo-deposit-disclosures');

      }
      if (e.target.name == "genesis-cc") {
        pay_toggle("genesis-cc");
        scrollToReview();
      }
      if (e.target.name == "sameaddress") {
        toggleAddress(e.target.checked);
      }
      if (
        e.target.id == "synchrony-btn" ||
        e.target.id == "synchrony-agree-btn"
      ) {
        submitSynchrony(orderData);
      }
      if (e.target.id == "synchrony-continue-btn") {
        document.querySelector(".promo-disclosures").classList.remove("hide");
      }
      if (
        e.target.id == "synchrony-cancel-btn" ||
        e.target.id == "synchrony-remove-btn" || e.target.id == "synchrony-deposit-cancel-btn"
      ) {
        clearFinancing(orderData);
      }
      if (e.target.id == "genesis-btn") {
        submitGenesis(orderData);
      }
      if (e.target.name == "gift-card") {
        pay_toggle("gift-card");
        scrollToReview();
      }
      if (e.target.id == "gift-card-btn") {
        submitGiftCard(orderData);
      }
      if (e.target.id == "reset-cc-btn" || e.target.id == "remove-cc-btn") {
        clearCybersource(orderData);
      }
      if (e.target.id == "remove-pp-btn") {
        clearPayPal(orderData);
      }
      if (e.target.id == "remove-apple-btn") {
        clearApplePay(orderData);
      }
      if (
        e.target.id == "reset-rtgcc-btn" ||
        e.target.id == "remove-financing-btn" ||
        e.target.className == "remove-financing"
      ) {
        clearFinancing(orderData);
        updateAmounts(orderData);
      }
      if (e.target.className == "wfg-remove-financing") {
        clearFinancing(orderData);
        clearWellsFargo(orderData);
        updateAmounts(orderData);
      }
      if (
        e.target.id == "reset-genesis-btn" ||
        e.target.id == "remove-genesis-btn"
      ) {
        clearGenesis(orderData);
        updateAmounts(orderData);
      }
      if (
        e.target.id == "reset-gift-card-btn" ||
        e.target.id == "remove-gift-card-btn"
      ) {
        clearGiftCard(orderData);
        updateAmounts(orderData);
      }

      if (e.target.id == "add-cc-btn") {
        document.querySelector(".add-cc-btn").classList.add("hide");
        document
          .querySelector(".options .tooltip.credit")
          .classList.add("hide");
        pay_toggle("cc");
      }
      if (e.target.id == "close-btn") {
        document.querySelector(".modal").classList.add("hide");
        document.querySelector(".terms-modal").classList.add("hide");
        document.querySelector(".promo-modal").classList.add("hide");
        document.querySelector(".modal-holder").classList.add("hide");
        document.querySelector(".modal-holder-deposit").classList.add("hide");
        document.querySelector(".modal-holder-wfg").classList.add("hide");
        document.querySelector('.modal-holder-promo').classList.add("hide");
      }
      if (e.target.id == "terms-link") {
        e.preventDefault();
        e.stopPropagation();
        document.querySelector(".terms-modal").classList.remove("hide");
        document.querySelector(".modal").classList.remove("hide");
        document.querySelector(".modal-holder").classList.remove("hide");
        return false;
      }
      if (e.target.id == "promo-details-link") {
        e.stopPropagation();
        document.querySelector(".modal").classList.remove("hide");
        document.querySelector('.modal-holder-promo').classList.remove("hide");
      }
      if (e.target.id == "promo-link") {

        e.stopPropagation();
        let plan = e.target.dataset.plan;

        e.target.classList.add("open");
        //document.querySelector(".promo-modal").classList.remove("hide");

        if(document.querySelector(`.promo-collapse.plan-${plan}.collapsed`))
          document.querySelector(`.promo-collapse.plan-${plan}`).classList.remove("collapsed");
        else {
          document.querySelector(`.promo-collapse.plan-${plan}`).classList.add("collapsed");
          e.target.classList.remove("open");
        }
        document.querySelector(".modal").classList.remove("hide");
        document.querySelector(".modal-holder").classList.remove("hide");

        return false;
      }
      if (e.target.className == "plan-cancel-btn") {
        document.querySelector(".modal").classList.add("hide");
        document.querySelector(".modal-holder").classList.add("hide");
      }
      if (e.target.id == "wfg-cancel-btn") {
        document.querySelector(".modal").classList.add("hide");
        document.querySelector(".modal-holder-wfg").classList.add("hide");
      }
      if (e.target.name == "other-amt") {
        if (parseFloat(e.target.value) > parseFloat(e.target.max))
          e.target.value = e.target.max;
        updateAmounts(orderData);
        //await updateDigibuyForm(rtgOrderData);
      }
      if (e.target.id == "apple-button-container") {
        if (!e.target.classList.contains("disabled")) loadApplePay(orderData);
      }
      if (e.target.className == "apple-pay-btn") {
        if (!document.querySelector(".apple-button-container.disabled").length)
          loadApplePay(orderData);
      }
      if (e.target.id == "plan-select-btn") {

        document.querySelector("#synchrony-cancel-btn")?.classList?.remove("hide");
        document.querySelector("#synchrony-agree-btn")?.classList?.remove("hide");

        let code = document.querySelector('input[name="long-term-plan"]:checked').value;
        let plan = longTermPlans[code];
        selectedPlan = plan;
        console.log(selectedPlan);
        document.querySelector(".terms-modal").innerHTML =
          plan?.termsAndConditions?.childMarkdownRemark?.html;
        document.querySelector(".promo-modal").innerHTML =
          plan?.promoMessage?.childMarkdownRemark?.html;
        document.querySelector(".promo-info .marketing").innerHTML =
          plan?.marketingMessage?.markdown?.childMarkdownRemark.html;

        let planCode = selectedPlan.serviceFinanceCode

        document.querySelector(".modal").classList.add("hide");
        document.querySelector(".modal-holder").classList.add("hide");

        if (document.querySelector(".promo-modal.hide")) {
          await selectFinancePlan(planCode);
          openModal("dbuyform3");
        }
      }

      if (e.target.className == "wfg-plan") {

        let code = document.querySelector('input[name="wfg-plan"]:checked').value;
        let plan = wfgPlans[code];
        wfgSelectedPlan = plan;
        console.log(wfgSelectedPlan);

      }

      if (e.target.id == "gift-card-balance-btn"){

        document.querySelector(".gift-card-errors").innerHTML = "";
        if(grecaptcha.getResponse() == ''){
          document
              .querySelector(".gift-card-errors")
              .insertAdjacentHTML(
                "afterbegin",
                `<p class="">Invalid captcha</p>`
              );
              return false;
        }
        let GCAcctNo = document.getElementById("gift-card-acct").value;
        let GCPIN = document.getElementById("gift-card-pin").value;
        if (GCAcctNo.length == 16 && GCPIN.length == 8 && grecaptcha.getResponse() != '') {
          document.querySelector("#gift-card-balance-btn").disabled = false;
          document.querySelector(".gift-card-errors").innerHTML = "";
          document
            .querySelector(".gift-card-box .balance-check")
            .classList.add("hide");
          document.querySelector(".gift-card-box .loading-icon").classList.remove('hide');
          giftCardData = await getGiftCardInfo(GCAcctNo, GCPIN, orderData);
          if (giftCardData.giftCardBalance) {
            document.querySelector(".options .cc").classList.add("hide");
            document.querySelector(".options .rtgcc").classList.add("hide");
            document.querySelector(".options .wfgcc").classList.add("hide");
            document
              .querySelector(".options .genesis-cc")
              .classList.add("hide");
            document.querySelector(".options .ppl").classList.add("hide");
            giftCardAcctNo = GCAcctNo;
            document.getElementById("gift-card-btn").classList.remove("hide");
            document.querySelector(".gift-card-box .loading-icon").classList.add('hide');
            document
              .querySelector(".gift-card-box .balance-check")
              .classList.remove("hide");
            document.querySelector(".gift-card-available-balance").innerHTML = "";
            document
              .querySelector(".gift-card-available-balance")
              .insertAdjacentHTML(
                "afterbegin",
                `$${parseFloat(giftCardData.giftCardBalance).toFixed(2)}`
              );
            document.querySelector("#gift-card-balance-btn").classList.add("hide");
            submitGiftCard(orderData);
            //loadPayPalButton(orderData);
          } else {
            //clearGiftCard(orderData);
            document.querySelector(".gift-card-errors").innerHTML = "";
            document.getElementById("gift-card-btn").classList.add("hide");
            grecaptcha.reset();
            document
              .querySelector(".gift-card-errors")
              .insertAdjacentHTML(
                "afterbegin",
                `<p class="">Error getting financing information, please try again</p>`
              );
          }
        }
      }
      if (e.target.name == "esign-consent" || e.target.name == "esign-signature") {
        if(document.querySelector('input[name="esign-consent"]:checked') && document.querySelector('input[name="esign-signature"]:checked')){
          document.querySelector('.wfg-continue-btn[data-step="2"]').removeAttribute('disabled');
        }
        else {
          document.querySelector('.wfg-continue-btn[data-step="2"]').setAttribute('disabled', true);
        }
      }
    });

    document
      .querySelector(".promo-disclosures .print-promo")
      .addEventListener("click", async function (e) {
        var pdf = new jsPDF();
        var specialElementHandlers = {};
        pdf.fromHTML(
          document.querySelector(".promo-disclosures .promo-info"),
          15,
          15,
          {
            width: 170,
            elementHandlers: specialElementHandlers,
          }
        );

        pdf.save("promotional_disclosures.pdf");
        return false;
      });

      document
      .querySelector(".promo-deposit-disclosures .print-promo")
      .addEventListener("click", async function (e) {
        var pdf = new jsPDF();
        var specialElementHandlers = {};
        pdf.fromHTML(
          document.querySelector(".promo-deposit-disclosures .promo-info"),
          15,
          15,
          {
            width: 170,
            elementHandlers: specialElementHandlers,
          }
        );

        pdf.save("promotional_disclosures.pdf");
        return false;
      });

    document.addEventListener("blur", async function (e) {
      if (e.target.id == "account_number_confirm") {
        getFinAccountData();
      }
    });
    document.addEventListener("focus", async function (e) {
      if (e.target.id == "account_number_confirm") {
        getFinAccountData();
      }
    });

    async function getFinAccountData(){
      financeAcctNo = document.querySelector('input[name="account_number_confirm"]')?.value?.toString();
        if (financeAcctNo.length == 16) {
          document.getElementById("submit-deposit-btn").classList.add("hide");
          document.querySelector(".modal-holder-deposit .loading-icon").classList.remove("hide");
          financeData = await getFinanceInfo(financeAcctNo, zipcode, orderData);
          if (parseInt(financeData.statusCode) == 200) {

            availableFinBalance = parseFloat(financeData.availableCredit).toFixed(2);
            document.getElementById("submit-deposit-btn").removeAttribute("disabled");
            document.getElementById("submit-deposit-btn").classList.remove("hide");
            document.querySelector(".modal-holder-deposit .loading-icon").classList.add("hide");
            document.querySelector(".modal-holder-deposit .plan-info").innerHTML = `<div class="plan-name"><label>Plan Name: </label>${orderData?.FinancePlan}</div><div class="last-four"><label>Last 4 Digits: </label>xxxxxxxxxxxx${orderData?.financeAccountNumber?.slice(-4)}</div>`;
            //document.querySelector(".modal-holder-deposit .plan-info").innerHTML = `<div class="plan-name"><label>Plan Name: </label>${orderData?.FinancePlan}</div><div class="last-four"><label>Last 4 Digits: </label>xxxxxxxxxxxx${orderData?.financeAccountNumber?.slice(-4)}</div><div class="avail-balance"><label>Available Balance: </label>${availableFinBalance}</div>`;
          }
          else {
            document.querySelector(".modal-holder-deposit .loading-icon").classList.add("hide");
            document.querySelector(".modal-holder-deposit .plan-info").innerHTML = `<div class="error">There was a problem getting your account data.</div>`;
          }
        }
    }

    async function getWfgFinAccountData(){
      if(document.querySelector('.wfg-plans .wfg-plan:checked')){
      wfgFinanceAcctNo = document.querySelector('input[name="wfg_account_number"]')?.value?.toString();
      let zipcode = document.querySelector('input[name="wfg_zip"]')?.value?.toString();
        if (wfgFinanceAcctNo.length == 16 && zipcode.length == 5) {

          document.querySelector('.modal-holder-wfg .loading-icon').classList.remove('hide');
          document.querySelector('.modal-holder-wfg .step-1').classList.add('hide');
          wfgFinanceData = await getWfgFinanceInfo(wfgFinanceAcctNo, zipcode, orderData);
          if(!wfgFinanceData.disclosureData){
            document.querySelector('.modal-holder-wfg .step-1').classList.remove('hide');
            document.querySelector('.modal-holder-wfg .loading-icon').classList.add('hide');
            document.querySelector('.modal-holder-wfg .step-1 .error').innerHTML = 'There was a problem retrieving disclosure data. Please try again.';
            return false;
          }
            console.log(wfgFinanceData)
            wfgAvailableFinBalance = parseFloat(wfgFinanceData.availableCredit).toFixed(2);
            document.querySelector('.modal-holder-wfg .step-2').classList.remove('hide');
            document.querySelector(".step-2 .disclosure").innerHTML = wfgFinanceData.disclosureData.disclosure;
            document.querySelector(".step-2 .esign-email").innerHTML = orderData.EmailAddress;
            document.querySelector(".step-2 .wfg-amount-financed").innerHTML = parseFloat(wfgFinAuthAmt - (wfgSelectedPlan?.downPaymentRequired ? downPaymentAmt : 0)).toFixed(2);

            document.querySelector('.modal-holder-wfg .loading-icon').classList.add('hide');


        }
      }
      else {
        document.querySelector('.modal-holder-wfg .step-1 .error').innerHTML = 'You must select a plan';
      }
    }

    document.addEventListener("keyup", async function (e) {
      if (e.target.name == "other-amt") {
        if (parseFloat(e.target.value) > parseFloat(e.target.max))
          e.target.value = e.target.max;
        updateAmounts(orderData);

      }

      if (e.target.name == "wfg_account_number" || e.target.name == "wfg_zip") {
        let wfgFinanceAcctNo = document.querySelector('input[name="wfg_account_number"]')?.value?.toString();
        let zipcode = document.querySelector('input[name="wfg_zip"]')?.value?.toString();

        if (wfgFinanceAcctNo.length == 16 && zipcode.length == 5) {
          document.querySelector('.wfg-continue-btn[data-step="1"]').removeAttribute('disabled');
        }
      }




      if (e.target.id == "account_number_confirm") {
        getFinAccountData();
      }

      if (e.target.id == "synchronyacct") {
        console.log(e.target.value.length);
        document.getElementById("synchrony-btn").classList.add("hide");
        document.querySelector("#synchrony-cancel-btn").classList.add("hide");
        document.querySelector("#synchrony-agree-btn").classList.add("hide");
        document.querySelector(".terms-conditions").classList.add("hide");
        document.querySelector(".promo-disclosures").classList.add("hide");
        document.querySelector(".plan-name").innerHTML = "";
        financeAcctNo = e.target.value;
        if (financeAcctNo.length == 16) {
          document.querySelector(".finance-errors").innerHTML = "";
          let showFinancePlans = true;
          if (
            orderData.FinDeposits &&
            orderData.FinDeposits.Deposit &&
            orderData.FinDeposits.Deposit[0] &&
            orderData.FinDeposits.Deposit[0].CashCode == "RGE"
          )
            showFinancePlans = false;
          document.querySelector(".loading-icon").classList.remove("hide");
          financeData = await getFinanceInfo(financeAcctNo, zipcode, orderData);
          if (parseInt(financeData.statusCode) == 200) {
            if (longTermFinanceAmt && showFinancePlans) {
              let eligiblePlans = financeData.eligiblePlans;
              let planItem = "";
              eligiblePlans.map((plan) => {
                let notice =
                  plan.downPaymentRequired && downPaymentAmt
                    ? `Small down payment required - <br/>$${parseFloat(downPaymentAmt).toFixed(2)} (shipping & sales tax).`
                    : `No down payment required.`;
                planItem += `<label class="plan-row"><input type="radio" name="long-term-plan" data-downpayment="${
                  plan.downPaymentRequired
                }" data-enc="${plan.encryptedFinanceCodes}" value="${
                  plan.financeCode.split("|")[0]
                }" ${eligiblePlans.length == 1 ? "checked" : ""} /><div>${
                  plan.siteFriendlyLabel
                }<div class="notice">${notice}<br/><a id="promo-link">Promotion Details</a></div></div></label>`;
              });
              planItem += `<button class="plan-select-btn">Submit</button>`;
              document.querySelector(".long-term-plans").innerHTML = planItem;
              document.querySelector(".loading-icon").classList.add("hide");
              document
                .querySelector(".long-term-plans")
                .classList.remove("hide");
              if (eligiblePlans.length == 1)
                document.querySelector('input[name="long-term-plan"]').click();
            } else {
              document.querySelector(".plan-name").innerHTML = "";
              document
                .querySelector(".terms-conditions")
                .classList.remove("hide");

              document
                .querySelector("#synchrony-cancel-btn")
                .classList.remove("hide");
              document
                .querySelector("#synchrony-agree-btn")
                .classList.remove("hide");
              document.querySelector(".plan-name").classList.remove("hide");
              document.querySelector(".loading-icon").classList.add("hide");
              document.querySelector(".available-balance").innerHTML = "";
              document
                .querySelector(".available-balance")
                .insertAdjacentHTML(
                  "afterbegin",
                  `$${parseFloat(financeData.availableCredit).toFixed(2)}`
                );
              document.querySelector(".plan-name").innerHTML =
                financeData.siteFriendlyLabel +
                `<br/><a id="promo-link">See full details here</a>`;
              document.querySelector(".terms-modal").innerHTML =
                financeData?.termsAndConditions?.childMarkdownRemark?.html;
              document.querySelector(".promo-modal").innerHTML =
                financeData?.promoMessage?.childMarkdownRemark?.html;
              document.querySelector(".promo-info .marketing").innerHTML =
                financeData?.marketingMessage?.markdown?.childMarkdownRemark.html;

              document.querySelector(".promo-disclosures .promo").innerHTML =
                financeData?.disclosureData?.promoDisclosure; //financeData.promoMessage.childMarkdownRemark.html;
              document
                .querySelector(".promo-disclosures")
                .classList.remove("hide");
            }
          } else {
            clearFinancing(orderData);
            document.querySelector(".finance-errors").innerHTML = "";
            document
              .querySelector(".finance-errors")
              .insertAdjacentHTML(
                "afterbegin",
                `<p class="">Error getting financing information, please try again</p>`
              );
          }

        }
      }
      if (e.target.id == "genesisacct" || e.target.id == "genesisphone") {
        console.log(e.target.value.length);
        document.getElementById("genesis-btn").classList.add("hide");

        document.querySelector(".terms-conditions").classList.add("hide");
        //document.querySelector('.plan-name').innerHTML = '';
        genesisAcctNo = document.getElementById("genesisacct").value;
        let genesisPhone = document.getElementById("genesisphone").value;
        if (genesisAcctNo.length == 16 && genesisPhone.length == 10) {
          document.querySelector(".genesis-errors").innerHTML = "";

          document.querySelector(".loading-icon").classList.remove("hide");
          genesisData = await getGenesisInfo(
            genesisAcctNo,
            genesisPhone,
            orderData
          );
          if (genesisData.availableCredit) {
            document
              .querySelector(".terms-conditions")
              .classList.remove("hide");
            document.getElementById("genesis-btn").classList.remove("hide");
            document.querySelector(".loading-icon").classList.add("hide");
            document.querySelector(".genesis-available-balance").innerHTML = "";
            document
              .querySelector(".genesis-available-balance")
              .insertAdjacentHTML(
                "afterbegin",
                `$${parseFloat(genesisData.availableCredit).toFixed(2)}`
              );
            /*document.querySelector('.plan-name').innerHTML = genesisData.siteFriendlyLabel + `<br/><a id="promo-link">Promotion Details</a>`;
						document.querySelector('.terms-modal').innerHTML = genesisData.termsAndConditions.childMarkdownRemark.html;
						document.querySelector('.promo-modal').innerHTML = genesisData.promoMessage.childMarkdownRemark.html;*/
            loadPayPalButton(orderData);

          } else {
            clearGenesis(orderData);
            document.querySelector(".genesis-errors").innerHTML = "";
            document
              .querySelector(".genesis-errors")
              .insertAdjacentHTML(
                "afterbegin",
                `<p class="">Error getting financing information, please try again</p>`
              );
          }

        }
      }
      if (e.target.id == "gift-card-acct" || e.target.id == "gift-card-pin") {
        let GCAcctNo = document.getElementById("gift-card-acct").value; //e.target.value;
        let GCPIN = document.getElementById("gift-card-pin").value;
        if (GCAcctNo.length == 16 && GCPIN.length == 8) {
          document.querySelector("#gift-card-balance-btn").disabled = false;
        }
      }
      /*if (e.target.id == "gift-card-acct" || e.target.id == "gift-card-pin") {
        document.getElementById("gift-card-btn").classList.add("hide");
        let GCAcctNo = document.getElementById("gift-card-acct").value; //e.target.value;
        let GCPIN = document.getElementById("gift-card-pin").value;
        if (GCAcctNo.length == 16 && GCPIN.length == 8 && grecaptcha.getResponse() != '') {
          document.querySelector(".gift-card-errors").innerHTML = "";
          document
            .querySelector(".gift-card-box .balance-check")
            .classList.add("hide");
          document.querySelector(".loading-icon").classList.remove("hide");
          giftCardData = await getGiftCardInfo(GCAcctNo, GCPIN, orderData);
          if (giftCardData.giftCardBalance) {
            document.querySelector(".options .cc").classList.add("hide");
            document.querySelector(".options .rtgcc").classList.add("hide");
            document
              .querySelector(".options .genesis-cc")
              .classList.add("hide");
            document.querySelector(".options .ppl").classList.add("hide");
            giftCardAcctNo = GCAcctNo;
            //document.querySelector('.terms-conditions').classList.remove('hide');
            document.getElementById("gift-card-btn").classList.remove("hide");
            document.querySelector(".loading-icon").classList.add("hide");
            document
              .querySelector(".gift-card-box .balance-check")
              .classList.remove("hide");
            document.querySelector(".gift-card-available-balance").innerHTML =
              "";
            document
              .querySelector(".gift-card-available-balance")
              .insertAdjacentHTML(
                "afterbegin",
                `$${parseFloat(giftCardData.giftCardBalance).toFixed(2)}`
              );

            //loadPayPalButton(orderData);
          } else {
            clearGiftCard(orderData);
            document.querySelector(".gift-card-errors").innerHTML = "";
            document
              .querySelector(".gift-card-errors")
              .insertAdjacentHTML(
                "afterbegin",
                `<p class="">Error getting financing information, please try again</p>`
              );
          }
          //document.querySelector('.balance-check').classList.remove('hide');
          console.log(giftCardData);
        }
      }*/

    });
    document.addEventListener("click", async function (e) {
      if(e.target.id == 'pay-btn'){

        document.querySelector("section.review-payment .errors").innerHTML = "";
        if (getTotalBalance(orderData) <= 0) {
          alert("Balance must be greater than 0.");
          return false;
        }
        curpay = 0.0; /*amount being paid right now [for thank you display]*/
        if (document.querySelector('input[name="sameaddress"]').checked) {
          orderData.BillingAddress = orderData.DeliveryAddress;
        } else {
          //get data from address form
          if (checkAddress()) {
            orderData.BillingAddress.Address1 = document.querySelector(
              '.address-section input[name="address1"]'
            ).value;
            orderData.BillingAddress.Address2 = document.querySelector(
              '.address-section input[name="address2"]'
            ).value;
            orderData.BillingAddress.City = document.querySelector(
              '.address-section input[name="city"]'
            ).value;
            orderData.BillingAddress.State = document.querySelector(
              '.address-section select[name="state"]'
            ).value;
            orderData.BillingAddress.Zip = document.querySelector(
              '.address-section input[name="zip"]'
            ).value;
          } else {
            alert("All address fields required");
            return false;
          }
        }
        if (document.getElementById("paypal_response").value != "")
          ppOrderData = JSON.parse(
            document.getElementById("paypal_response").value
          );

        if (
          (!orderData.EmailAddress || orderData.EmailAddress == "") &&
          !validateEmail(document.getElementById("email_addr").value)
        ) {
          showPayErrors("A valid email address is required for orders.");
          return false;
        }

        if (!document.querySelector('input[name="toc-chk"]').checked) {
          showPayErrors("You must agree to the Terms and Conditions.");
          return false;
        }

        if (
          !document.querySelector(".protection-plan.hide") &&
          !document.querySelector('input[name="esc-chk"]').checked
        ) {
          showPayErrors("You must agree to the Furniture Protection Plan.");
          return false;
        }

        if (
          !document.querySelector(".adjustable-base-plan.hide") &&
          !document.querySelector('.adjustable-base-plan input[name="esc-chk"]')
            .checked
        ) {
          showPayErrors("You must agree to the Furniture Protection Plan.");
          return false;
        }

        if (
          !document.querySelector(".consent.hide") &&
          !document.querySelector('input[name="con-chk"]').checked
        ) {
          showPayErrors("You must agree to the Promotional Agreement.");
          return false;
        }

        if (!orderData.EmailAddress || orderData.EmailAddress == "") {
          orderData.EmailAddress = document.getElementById("email_addr").value;
          rtgOrderData.EmailAddress = orderData.EmailAddress;
          initFingerPrint();
        }

        document.getElementById("pay-btn").setAttribute("disabled", true);

        const orderPayData = {
          shippingAddress: {
            address1: orderData.DeliveryAddress.Address1,
            address2: orderData.DeliveryAddress.Address2,
            city: orderData.DeliveryAddress.City,
            state: orderData.DeliveryAddress.State,
            zipcode: formatZip(orderData.DeliveryAddress.Zip),
            plus4: "",
            countryCode: "us",
          },
          billingAddress: {
            address1: orderData.BillingAddress.Address1,
            address2: orderData.BillingAddress.Address2,
            city: orderData.BillingAddress.City,
            state: orderData.BillingAddress.State,
            zipcode: formatZip(orderData.BillingAddress.Zip),
            plus4: "",
            countryCode: "us",
          },
          orderId: orderData.OrderNumber,
          storeNumber: orderData.StoreNumber,
          division: orderData.Division,
          customer: {
            firstName: orderData.Customer.FirstName,
            lastName: orderData.Customer.LastName,
            email: orderData.EmailAddress,
            phoneNumber: orderData.Customer.PhoneNumber.replace("/", "")
              .replace("-", "")
              .replace("NPI", ""),
          },
          cartToken: orderData.OrderNumber,
        };

        //if delivery upgrade
        if (
          typeof document.getElementById("upgrade") != "undefined" &&
          document.getElementById("upgrade") != null
        ) {
          if (
            document.getElementById("upgrade").checked &&
            orderData.upgradeDelivery &&
            orderData.upgradeInfo
          ) {
            let totalTax =
              parseFloat(orderData.TaxAmount) +
              parseFloat(orderData.upgradeInfo.tax);
            orderPayData["deliveryUpgrade"] = {
              deliveryCharge: orderData.upgradeInfo.deliveryCharge,
              totalTax,
            };
          }
        }

        //if financing used - DISABLED FOR NOW
        if (false &&
          longTermFinanceAmt &&
          financeAcctNo.length == 16 &&
          document.querySelector('input[name="long-term-plan"]:checked') &&
          document.querySelector('input[name="long-term-plan"]:checked').value && !useExistingDeposit
        ) {
          let totalBalance = getTotalBalance(orderData);

          let downPaymentRequired = selectedPlan.downPaymentRequired;
          console.log(downPaymentRequired);
          let authAmount =
            availableFinBalance < longTermFinanceAmt
              ? availableFinBalance
              : downPaymentRequired === "true"
              ? longTermFinanceAmt
              : totalBalance;
              console.log('aaaa')
              console.log(authAmount)
          if (downPaymentRequired && authAmount >= downPaymentAmt)
            authAmount -= parseFloat(downPaymentAmt);
          authAmount = parseFloat(authAmount).toFixed(2);
          let financePlan = document.querySelector(
            'input[name="long-term-plan"]:checked'
          ).value;
          curpay += parseFloat(authAmount);
          console.log(authAmount)
          orderPayData["financePayment"] = {
            accountNumber: financeAcctNo,
            authAmount: parseFloat(authAmount),
            uvFinancePlan: financePlan,
            encryptedFinancePlans: document.querySelector(
              'input[name="long-term-plan"]:checked'
            ).dataset.enc,
          };
        } else if (false &&
          financeData.availableCredit && !useExistingDeposit  &&
          /* financeData.availableCredit > getTotalBalance(orderData) && */ financeAcctNo.length == 16
        ) {
          let totalBalance = getTotalBalance(orderData);
          let authAmount =
            availableFinBalance < totalBalance
              ? availableFinBalance
              : totalBalance;
          finAuthAmt = authAmount;
          curpay += parseFloat(authAmount);
          orderPayData["financePayment"] = {
            accountNumber: financeAcctNo,
            authAmount: parseFloat(authAmount).toFixed(2),
            uvFinancePlan: financeData.uvFinancePlan,
            encryptedFinancePlans: financeData.encryptedFinancePlans,
          };
        }

        //new Financing
        if (
          (longTermFinanceAmt || (orderData?.financeProvider?.includes('SYN') && orderData?.mattressBalance)) &&
          document.querySelector('input[name="long-term-plan"]:checked') &&
          document.querySelector('input[name="long-term-plan"]:checked').value && !useExistingDeposit && digiBuyState?.clientToken
        ) {
          let totalBalance = getTotalBalance(orderData);
          if (digiBuyState?.payerInfo?.billingAddress?.Address1) {
            orderPayData.billingAddress.address1 =
              digiBuyState?.payerInfo?.billingAddress?.Address1;
            orderPayData.billingAddress.address2 =
              digiBuyState?.payerInfo?.billingAddress?.Address2;
            orderPayData.billingAddress.city =
              digiBuyState?.payerInfo?.billingAddress?.City;
            orderPayData.billingAddress.state =
              digiBuyState?.payerInfo?.billingAddress?.State;
            orderPayData.billingAddress.zipcode =
              digiBuyState?.payerInfo?.billingAddress?.ZipCode;
          }

          console.log(digiBuyState);
          let downPaymentRequired = selectedPlan.downPaymentRequired; //document.querySelector('input[name="long-term-plan"]:checked').dataset.downpayment;
          console.log(downPaymentRequired);
          console.log('fin: '+availableFinBalance)
          console.log('long: '+longTermFinanceAmt)
          let authAmount =
            availableFinBalance < longTermFinanceAmt
              ? availableFinBalance
              : downPaymentRequired === "true"
              ? longTermFinanceAmt
              : totalBalance;
              console.log(authAmount)
          if (downPaymentRequired && authAmount >= downPaymentAmt)
            authAmount -= parseFloat(downPaymentAmt);
          if(digiBuyState.currentTotal > 0 && digiBuyState.currentTotal < totalBalance)
            authAmount = digiBuyState.currentTotal;
          authAmount = parseFloat(authAmount).toFixed(2);
          let financePlan = document.querySelector(
            'input[name="long-term-plan"]:checked'
          ).value;
          curpay += parseFloat(authAmount);
          orderPayData["synchronyPayment"] = {
            userToken: digiBuyState?.clientToken,
            authAmount: parseFloat(authAmount),
            uvFinancePlan: financePlan,
            encryptedFinancePlans: document.querySelector(
              'input[name="long-term-plan"]:checked'
            ).dataset.enc,
          };
        } else if (
          financeData.availableCredit &&
          /* financeData.availableCredit > getTotalBalance(orderData) && */ financeAcctNo.length == 16 && !useExistingDeposit
        ) {
          console.log(useExistingDeposit)

          let totalBalance = getTotalBalance(orderData);
          let authAmount =
            availableFinBalance < totalBalance
              ? availableFinBalance
              : totalBalance;
          finAuthAmt = authAmount;
          curpay += parseFloat(authAmount);
          orderPayData["synchronyPayment"] = {
            userToken: digiBuyState?.clientToken,
            authAmount: parseFloat(authAmount),
            uvFinancePlan: financeData.uvFinancePlan,
            encryptedFinancePlans: financeData.encryptedFinancePlans,
          };
        }
        //NEW Existing Deposit
        if(orderData?.financePaymentEligible && orderData?.addonFinanceEligible && useExistingDeposit && orderData?.financeAccountNumber){
          //let totalBalance = getTotalBalance(orderData);
          let accountNumber = document.querySelector('input[name="account_number_confirm"]')?.value?.toString();
          orderPayData['addonFinancePayment'] = {
            accountNumber,
            authAmount: finAuthAmt
          };
          curpay += parseFloat(finAuthAmt);
        }

        //WELLS FARGO
        if(orderData?.financePaymentEligible && orderData?.financeProvider?.includes('WFG') && wfgFinAuthAmt > 0){
          orderPayData['wfgPayment'] = {
            accountKey: wfgFinanceData?.accountKey,
            authAmount: parseFloat(wfgFinAuthAmt),
            uvFinancePlan: wfgSelectedPlan?.financeCode,
            planNumber: wfgSelectedPlan?.serviceFinanceCode
          };
          curpay += parseFloat(wfgFinAuthAmt);
        }

        //if genesis used
        if (
          genesisData.availableCredit &&
          /* financeData.availableCredit > getTotalBalance(orderData) && */ genesisAcctNo.length ==
            16
        ) {
          let totalBalance = getTotalBalance(orderData);
          let authAmount =
            availableGenesisBalance < totalBalance
              ? availableGenesisBalance
              : totalBalance;
          genesisAuthAmt = authAmount;
          curpay += parseFloat(authAmount);
          orderPayData["genesisPayment"] = {
            accountNumber: genesisAcctNo,
            authAmount: parseFloat(authAmount),
          };
        }

        //if giftcard used
        if (
          giftCardAuthAmt &&
          giftCardData.giftCardBalance &&
          /* financeData.availableCredit > getTotalBalance(orderData) && */ giftCardAcctNo.length ==
            16
        ) {
          let totalBalance = getTotalBalance(orderData);
          let pinNumber = document.querySelector("#gift-card-pin").value;
          //let authAmount = (availableGiftCardBalance < totalBalance) ? availableGiftCardBalance : totalBalance;
          //giftCardAuthAmt = authAmount;
          curpay += parseFloat(giftCardAuthAmt);
          orderPayData["giftcardPayment"] = {
            cardNumber: giftCardAcctNo,
            pin: pinNumber,
            authAmount: parseFloat(giftCardAuthAmt),
          };
        }

        if (document.getElementById("flexresponse")) {
          let cyberResponse = document.getElementById("flexresponse").value;
          if (cyberResponse != "") {
            //console.log(JSON.parse(cyberResponse).token);

            let cybertoken = ccPaymentInfo.paymentProperties.token; //JSON.parse(cyberResponse).token;
            let expMonth = document.getElementById("expMonth").value;
            let expYear = document.getElementById("expYear").value.substr(-2);
            let totalBalance = getTotalBalance(orderData);
            let authAmount =
              totalBalance -
              finAuthAmt -
              availableGenesisBalance -
              wfgFinAuthAmt;
            authAmount = parseFloat(authAmount);

            if (
              longTermFinanceAmt &&
              downPaymentAmt > 0 &&
              selectedPlan.downPaymentRequired
            )
              authAmount = downPaymentAmt;
            else if(digiBuyState.currentTotal < getTotalBalance(orderData) && digiBuyState.currentTotal > 0)
              authAmount = getTotalBalance(orderData) - digiBuyState.currentTotal;
            else if (
              financeData.availableCredit < getTotalBalance(orderData) &&
              longTermFinanceAmt &&
              !selectedPlan.downPaymentRequired
            )
              authAmount = getTotalBalance(orderData) - availableFinBalance;
            else if (giftCardAuthAmt)
              authAmount = getTotalBalance(orderData) - giftCardAuthAmt;
            console.log(authAmount);
            ccAuthAmt = authAmount;
            curpay += parseFloat(authAmount);
            //for CC payment
            if (cybertoken) {
              orderPayData["creditcardPayment"] = {
                token: cybertoken,
                authAmount: parseFloat(parseFloat(authAmount).toFixed(2)),
                expMonthYear: expMonth + expYear,
              };
            }
          }
        }
        // Paypal
        if (ppAuthAmt > 0 && ppOrderData.orderID && ccAuthAmt <= 0) {
          curpay += parseFloat(ppAuthAmt);
          orderPayData["paypalPayment"] = {
            payerStatus: "verified",
            paypalOrderId: ppOrderData.orderID,
            authAmount: parseFloat(ppAuthAmt),
            payerEmail: orderData.EmailAddress,
          };
        }
        // Apple Pay
        let appleResponse = document.getElementById("apple_response").value;
        if (appleAuthAmt > 0 && appleResponse != "" && ccAuthAmt <= 0) {
          let appletoken = JSON.parse(appleResponse);
          curpay += parseFloat(appleAuthAmt);
          orderPayData["applePayPayment"] = {
            ...appletoken,
            authAmount: parseFloat(appleAuthAmt),
          };
        }





        if(escAddData?.orderKey && escAddData?.lineItems.length && escAddData?.orderKey == orderData.orderKey){
          let lineItems = escAddData?.lineItems;
          lineItems.map(item => {
            item.skuId = item.sku;
            //delete item.quantity;
            delete item.deliveryType;
            delete item.warrantyPrice;
            delete item.unitPrice;
            //delete item.plan;
            //delete item.lineNumber;
            delete item.sku;

          });
          orderPayData["orderModification"] = {
            context: "addEsc",
            lineItems: escAddData?.lineItems
          };
        }

        if(mattressAddData?.orderKey && mattressAddData?.skus.length && mattressAddData?.orderKey == orderData.orderKey){
          let lineItems = mattressAddData?.skus;
          console.log(lineItems)
          lineItems.map(item => {
            item.skuId = item.sku;
            //delete item.quantity;
            delete item.deliveryType;
            delete item.warrantyPrice;
            delete item.unitPrice;
            //delete item.plan;
            //delete item.lineNumber;
            delete item.sku;

          });
          orderPayData["orderModification"] = {
            context: "mattressUpsell",
            lineItems: mattressAddData?.skus
          };
        }

        if(orderUpsellData?.orderKey && orderUpsellData?.skus.length && orderUpsellData?.orderKey == orderData.orderKey){
          let lineItems = orderUpsellData?.skus;

          orderPayData["orderModification"] = {
            context: "upsell",
            upsell: lineItems
          };
        }

console.log(orderPayData)

const doPolling = async (data, timer) => {
  let pollTimeout = setTimeout(async() => {
    let completed = await makeOrderRequest(data);
    if(completed){
      clearTimeout(pollTimeout);
      clearTimeout(timer);
      show_thank_you(orderKey, orderId, zipcode, curpay, orderData);
    }
    else
      doPolling(data);
  }, 2000)

  async function makeOrderRequest(orderUpsellData){
    let action = "/ordersHistoryByKey";
    let orderRes = await fetch(`${endpoint}${action}?orderKey=${orderKey}`);
    let orderData = await orderRes.json();
    console.log(orderData);
    console.log(orderUpsellData);
    let completed = false;
    orderUpsellData.skus.map(item => {
      if(orderData.LineItems.LineItem?.filter(p => p.Sku == item?.to).length)
        completed = true;
    })
    return completed;
  }
}

//return false;

        document
        .querySelector(".container .main-section")
        .classList.add("hide");
        document.querySelector("section.loading").classList.remove("hide");
        if(orderUpsellData)
          showTimer(20);
//return false;
        let action = "/payonline";
        let payRes = await fetch(`${endpoint}${action}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(orderPayData),
        });
        let payData = await payRes.json();
        console.log(payData);
        if (payData.auth == "success") {
          scrollToTop();
          document
            .querySelector(".container .main-section")
            .classList.add("hide");
          document.querySelector("section.loading").classList.remove("hide");
          if (orderPayData.applepayPayment)
            session.completePayment(window.ApplePaySession.STATUS_SUCCESS);

          /*on Payment Submit*/
          let submitAnalyticsObj = {
            OrderNumber: orderData.OrderNumber,
            Status: orderData.orderStatus,
            DeliveryDate: orderData.DeliveryDate,
            OrderDate: orderData.OrderDate,
            Balance: orderData.Balance,
            OrderTotal: orderData.OrderTotal,
            Division: orderData.Division,
            //premiumDelivery: orderData.premiumDelivery,
            //premiumDeliveryCharge: orderData?.upgradeInfo,
            PaymentType: orderData.PaymentType,
          };
          if(orderPayData["deliveryUpgrade"]){
            submitAnalyticsObj['premiumDelivery'] = orderData.premiumDelivery;
            submitAnalyticsObj['premiumDeliveryCharge'] = orderData?.upgradeInfo;
          }


          dataLayer.push({
            event: "paymentSubmit",
            orderStatus: submitAnalyticsObj
          });

          dataLayer.push({
            event: "post_order_checkout_pay",
          });

          //if(orderAddData)
            //eraseCookie('orderAddData');
            if((escAddData?.orderKey && escAddData?.lineItems?.length && escAddData?.orderKey == orderData.orderKey) || (mattressAddData?.orderKey && mattressAddData?.skus.length && mattressAddData?.orderKey == orderData.orderKey) || (orderUpsellData?.orderKey && orderUpsellData?.orderKey == orderData.orderKey)){
              let revenue = 0;
              if(mattressAddData?.orderKey && mattressAddData?.skus.length && mattressAddData?.orderKey == orderData.orderKey){
                mattressAddData = getCookie("mattressAddData") ? JSON.parse(getCookie("mattressAddData")): '';
                await Promise.all(mattressAddData?.skus.map(async item => {
                  revenue += parseFloat(item.unitPrice);
                  item.sku = item.skuId
                  if(item.title)
                    item.name = item.title;
                  if(item.deliveryType)
                    item.delivery_type = item.deliveryType;
                  item.price = item.unitPrice;
                  delete item.skuId;
                  delete item.provider;
                  delete item.plan;
                  delete item.lineNumber;
                  delete item.title;
                  delete item.deliveryType;

                }));
              }
              if(escAddData?.orderKey && escAddData?.lineItems?.length && escAddData?.orderKey == orderData.orderKey) {
                escAddData?.lineItems.map(item => {
                  revenue += parseFloat(item.unitPrice);
                });
              }

              if(orderUpsellData?.orderKey && orderUpsellData?.orderKey == orderData.orderKey) {
                dataLayer.push({
                  event: "ee_purchase",
                    ecommerce: {
                        purchase: {
                            id: orderData.OrderNumber,
                            revenue: upsellAnalytics.revenue,
                            tax: upsellAnalytics.tax,
                            products: upsellAnalyticsProds

                        }
                    },
                    payonline_origin: "post_order_upsell",
                    cart_type: "payonline"
                });
              }
              else {
                let addData = escAddData?.lineItems?.length ? escAddData?.lineItems : mattressAddData?.skus;

                dataLayer.push({
                  event: "ee_purchase",
                  ecommerce: {
                    purchase: {
                      tax: orderData?.newTax,
                      revenue: parseFloat(revenue),
                      products: addData
                    },
                  },
                });
                console.log({
                  event: "ee_purchase",
                  ecommerce: {
                    purchase: {
                      tax: orderData?.newTax,
                      revenue: parseFloat(revenue),
                      products: addData
                    },
                  },
                })
              }

            }

          let timeoutAmt = 3000;
          if(orderUpsellData){
            timeoutAmt = 20000;
          }
          let thanksTimeout = setTimeout(() => {
            show_thank_you(orderKey, orderId, zipcode, curpay, orderData);
          }, timeoutAmt);

          if(mattressAddData)
            eraseCookie('mattressAddData');
          if(escAddData)
            eraseCookie('escAddData');
          if(orderUpsellData){
            eraseCookie('orderUpsellData');
            doPolling(orderUpsellData, thanksTimeout);

          }





          //window.location.href = `thank-you.html?orderId=${orderId}&zipcode=${zipcode}`;
        }
        else if(payData?.error && payData?.error?.message == 'Invalid Account Number') {
          document
            .querySelector(".container .main-section")
            .classList.remove("hide");
          document.querySelector("section.loading").classList.add("hide");
          document.getElementById("pay-btn").removeAttribute("disabled");

          showPayErrors(
            "The account number you entered does not match the one used for this order. Please re-check and try again."
          );
        }
        else {
          document
            .querySelector(".container .main-section")
            .classList.remove("hide");
          document.querySelector("section.loading").classList.add("hide");
          document.getElementById("pay-btn").removeAttribute("disabled");
          pay_toggle("cc");
          document.querySelector(".cc-box-success")?.classList?.remove("hide");
          showPayErrors(
            "There was a problem processing your payment, please try again or enter a different credit card or payment type."
          );
          if (orderPayData.applepayPayment)
            session.completePayment(window.ApplePaySession.STATUS_FAILURE);
        }
      }
      });


    await loadCybersource(orderData);

    let formTimeout = setTimeout(() => {
      window.location.href = `${redirurl}?orderKey=${orderData.orderKey}`;
    }, 900000);
  } else {
    showErrors("No Order Key");
  }



  const showTimer = (countdown) => {
    document.querySelector('.loading .timer-counter').classList.remove('hide');
    let interval = setInterval(() => {

      document.querySelector('.loading .timer-counter').innerHTML = countdown;

      console.log(countdown)
      if(countdown <= -2) {
        clearInterval(interval);
        document.querySelector('.loading .timer-counter').classList.add('hide');
      }
      countdown--;

    }, 1000);
  }
});



const selectFinancePlan = async (planCode) => {
  digiBuyState.financeCode = planCode;
  await updateDigibuyForm(rtgOrderData);
};

const updateDigibuyForm = async (orderData) => {

  let totalBalance = getTotalBalance(orderData);
  document.querySelector('input[name="processInd"]').value =
    digiBuyState.processInd;
  document.querySelector('input[name="iniPurAmt"]').value = selectedPlan.downPaymentRequired ? parseFloat(totalBalance - downPaymentAmt).toFixed(2) : (digiBuyState.currentTotal ? parseFloat(digiBuyState.currentTotal).toFixed(2) : parseFloat(totalBalance).toFixed(2));
  document.querySelector('input[name="tokenId"]').value =
    digiBuyState?.clientToken;
  document.querySelector('input[name="merchantID"]').value = GATSBY_CREDIT_MID;
  document.querySelector('input[name="clientTransId"]').value =
    orderData?.OrderNumber;

  document.querySelector('input[name="phoneNumber"]').value =
    orderData?.Customer?.PhoneNumber;
  document.querySelector('input[name="emailAddress"]').value =
    orderData?.EmailAddress;
  document.querySelector('input[name="custFirstName"]').value =
    orderData?.Customer?.FirstName;
  document.querySelector('input[name="custLastName"]').value =
    orderData?.Customer?.LastName;
  document.querySelector('input[name="custZipCode"]').value =
    digiBuyState?.payerInfo?.billingAddress?.ZipCode ||
    orderData?.BillingAddress?.Zip;
  document.querySelector('input[name="custAddress1"]').value =
    digiBuyState?.payerInfo?.billingAddress?.Address1 ||
    orderData?.BillingAddress?.Address1;
  document.querySelector('input[name="custAddress2"]').value =
    digiBuyState?.payerInfo?.billingAddress?.Address2 ||
    orderData?.BillingAddress?.Address2;
  document.querySelector('input[name="custCity"]').value =
    digiBuyState?.payerInfo?.billingAddress?.City ||
    orderData?.BillingAddress?.City;
  document.querySelector('input[name="custState"]').value =
    digiBuyState?.payerInfo?.billingAddress?.State ||
    orderData?.BillingAddress?.State;
  document.querySelector('input[name="transPromo1"]').value =
    digiBuyState.financeCode; //GET THIS ONE - WHERE IS IT UPDATED??
  document.querySelector('input[name="transAmount1"]').value = selectedPlan.downPaymentRequired ? parseFloat(totalBalance - downPaymentAmt).toFixed(2) : (digiBuyState.currentTotal ? parseFloat(digiBuyState.currentTotal).toFixed(2) : parseFloat(totalBalance).toFixed(2));
  document.querySelector('input[name="defaultPromoCode"]').value =
    digiBuyState.financeCode; //GET THIS ONE - WHERE IS IT UPDATED??

  //openModal('dbuyform3');
};

const openModal = async (formId) => {

  document.querySelector(".pp-errors").innerHTML = "";
  if (digiBuyState.processInd === 1) {
    if (document.getElementById("dbuymodal2")) {
      document.getElementById("dbuymodal2").remove();
    }
  }
  if (!digiBuyState.clientToken) {
    await fetchClientToken();
  }
  digiBuyState.clicked = true;
  const form = document.getElementById(formId);
  window.syfDBuy && window.syfDBuy.calldBuyProcess(form);
  window.addEventListener("message", messageEvent);
};

const messageEvent = (event) => {
  const updateClickedState = () => (digiBuyState.clicked = false);
  //const checkTokenStatus = () => this.checkTokenStatusMethod()

  if (
    typeof event.data === "string" &&
    (event.data === "Close Model" ||
      event.data === "Return To Merchant Shipping")
  ) {
    updateClickedState();
    checkTokenStatusMethod();
  }
};

const getFinancePlanInfo = async (orderData) => {
  let finData = {};

  //get finance plan info
  let finPlanRes = await fetch(financeplansendpointadmin);
  let finPlanData = await finPlanRes.json();

  let division = orderData.Division.substr(0, 2).toLowerCase();

  let eligiblePlans = finPlanData[`${division}0`];

  longTermFinanceAmt = orderData?.longTermFinanceOption?.financeAmount
    ? orderData?.longTermFinanceOption?.financeAmount
    : 0;
  downPaymentAmt = 0;
  if (longTermFinanceAmt) {
    downPaymentAmt = parseFloat(orderData?.longTermFinanceOption?.downPaymentToCollect) || 0;

    eligiblePlans = eligiblePlans.filter(
      (p) =>
        p.name !== "GENESIS" &&
        p.name !== "Genesis" /*&& p.downPaymentRequired == true*/ &&
        p.name.indexOf('WFG') == -1 &&
        p.threshold < getTotalBalance(orderData)
    );
    let inStoreDeposits = 0;
    if (
      orderData.Deposits &&
      orderData.Deposits.Deposit &&
      orderData.Deposits.Deposit.length
    )
      inStoreDeposits = parseFloat(
        orderData.Deposits.Deposit[0].AuthorizedAmount
      );

    let downpaymentPlans = eligiblePlans
      .filter((p) => p.downPaymentRequired == true)
      .sort(function (a, b) {
        return a.priority - b.priority;
      });
    let noDownpaymentPlans = eligiblePlans.filter(
      (p) => p.downPaymentRequired == false
    );
    downpaymentPlans = downpaymentPlans[0] ? [downpaymentPlans[0]] : [];

    eligiblePlans = downpaymentPlans.concat(noDownpaymentPlans);

    eligiblePlans.map((plan) => {
      let code = plan?.financeCode.split("|")[0];
      longTermPlans[code] = plan;
    });
  } else {
    eligiblePlans = eligiblePlans.filter(
      (p) =>
        p.name !== "GENESIS" &&
        p.name !== "Genesis" &&
        p.name.indexOf('WFG') == -1 &&
        p.downPaymentRequired == false &&
        p.threshold < getTotalBalance(orderData)
    );
    eligiblePlans.map((plan) => {
      let code = plan?.financeCode.split("|")[0];
      longTermPlans[code] = plan;
    });
  }


  if (eligiblePlans.length) {
    let selectedPlan = eligiblePlans[0];
    let uvFinancePlan = selectedPlan?.financeCode.split("|")[0];
    let encryptedFinancePlans = selectedPlan?.encryptedFinanceCodes;
    finData["uvFinancePlan"] = uvFinancePlan;
    finData["encryptedFinancePlans"] = encryptedFinancePlans;
    finData["siteFriendlyLabel"] = selectedPlan.siteFriendlyLabel;
    finData["promoMessage"] = selectedPlan.promoMessage;
    finData["promoMessage"] = selectedPlan.promoMessage;
    finData["termsAndConditions"] = selectedPlan.termsAndConditions;
    finData["marketingMessage"] = selectedPlan.marketingMessage;
    finData["shortPromoMessage"] =
      selectedPlan.marketingMessage && selectedPlan.marketingMessage.markdown
        ? selectedPlan.marketingMessage.markdown
        : "";
    console.log(selectedPlan);
    let disclosureData = []; //await getFinanceDisclosure(acct_no, orderData, finData);
    finData["disclosureData"] = disclosureData;
    finData["eligiblePlans"] = eligiblePlans;
    finData["downPaymentAmt"] = downPaymentAmt;
  }
  availableFinBalance = finData.availableCredit;
  return finData;
};


const showFinancePlans = async (orderData) => {
  let showFinancePlans = true;
  var financeData = await getFinancePlanInfo(orderData);

  if ((longTermFinanceAmt || orderData.financeProvider) && showFinancePlans) {
    let eligiblePlans = financeData.eligiblePlans;
    let planItem = "";
    eligiblePlans.map((plan) => {
      let notice =
        plan.downPaymentRequired && financeData.downPaymentAmt
          ? `Small down payment required - <br/>$${financeData.downPaymentAmt} (shipping & sales tax).`
          : `No down payment required.`;
      planItem += `<label class="plan-row"><input type="radio" name="long-term-plan" data-downpayment="${
        plan.downPaymentRequired
      }" data-enc="${plan.encryptedFinanceCodes}" value="${
        plan.financeCode.split("|")[0]
      }" ${eligiblePlans.length == 1 ? "checked" : ""} /><div>${
        plan.siteFriendlyLabel
      }<div class="notice">${notice}<br/><a id="promo-link" data-plan="${plan.financeCode.split("|")[0]}">Promotion Details <svg class="MuiSvgIcon-root-249" focusable="false" viewBox="0 0 24 24" aria-hidden="true"><path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"></path></svg></a></div></div></label>`;
      planItem += `<div class="plan-${plan.financeCode.split("|")[0]} promo-collapse collapsed"><div class="content-inner">${document.querySelector(".promo-modal").innerHTML =
      plan?.promoMessage?.childMarkdownRemark?.html}</div></div>`
    });
    planItem += `<div class="button-row"><button id="plan-select-btn" class="plan-select-btn primary">Submit</button><button class="plan-cancel-btn">Cancel</button></div>`;
    document.querySelector(".long-term-plans").innerHTML = planItem;
    document.querySelector(".loading-icon").classList.add("hide");
    document.querySelector(".long-term-plans").classList.remove("hide");
    document.querySelector(".modal-holder").classList.remove("hide");
    document.querySelector(".modal").classList.remove("hide");

    document.querySelector(".promo-disclosures .promo").innerHTML =
      financeData?.disclosureData?.promoDisclosure;
    document.querySelector(".promo-disclosures").classList.remove("hide");
    if (eligiblePlans.length == 1)
      document.querySelector('input[name="long-term-plan"]').click();
  } else {
    console.log('not long term financing');
    document.querySelector(".plan-name").innerHTML = "";
    document.querySelector(".terms-conditions").classList.remove("hide");
    //document.getElementById('synchrony-btn').classList.remove('hide');
    document.querySelector("#synchrony-cancel-btn").classList.remove("hide");
    document.querySelector("#synchrony-agree-btn").classList.remove("hide");
    document.querySelector(".plan-name").classList.remove("hide");
    document.querySelector(".loading-icon").classList.add("hide");
    document.querySelector(".available-balance").innerHTML = "";
    document
      .querySelector(".available-balance")
      .insertAdjacentHTML(
        "afterbegin",
        `$${parseFloat(financeData.availableCredit).toFixed(2)}`
      );
    document.querySelector(".plan-name").innerHTML =
      financeData.siteFriendlyLabel +
      `<br/><a id="promo-link">See full details here</a>`;
    document.querySelector(".terms-modal").innerHTML =
      financeData?.termsAndConditions?.childMarkdownRemark?.html;
    document.querySelector(".promo-modal").innerHTML =
      financeData?.promoMessage?.childMarkdownRemark?.html;
    document.querySelector(".promo-info .marketing").innerHTML =
      financeData?.marketingMessage?.markdown?.childMarkdownRemark.html;

    document.querySelector(".promo-disclosures .promo").innerHTML =
      financeData?.disclosureData?.promoDisclosure; //financeData.promoMessage.childMarkdownRemark.html;
    document.querySelector(".promo-disclosures").classList.remove("hide");
  }

};


// WELLS FARGO
const filterWfgPlans = (plans, orderData) => {
  // Filter by WFG provider first
  let wfgPlans = plans.filter(p => p.name.indexOf("WFG") != -1);

  // Get order total for threshold comparison
  let orderTotal = getTotalBalance(orderData);

  // Filter by threshold
  wfgPlans = wfgPlans.filter(plan => {
    if (!plan.threshold) return true;
    return orderTotal >= parseFloat(plan.threshold);
  });

  // Separate by down payment requirement
  let dpPlans = wfgPlans.filter(p => p.downPaymentRequired === true);
  let noDpPlans = wfgPlans.filter(p => p.downPaymentRequired === false);

  // Select best plan of each type
  let selectedPlans = [];
  if (dpPlans.length > 0) {
    let bestDpPlan = dpPlans.sort((a, b) => {
      let priorityDiff = (parseFloat(b.priority) || 0) - (parseFloat(a.priority) || 0);
      if (priorityDiff !== 0) return priorityDiff;
      return (parseFloat(b.numberOfMonths) || 0) - (parseFloat(a.numberOfMonths) || 0);
    })[0];
    selectedPlans.push(bestDpPlan);
  }
  if (noDpPlans.length > 0) {
    let bestNoDpPlan = noDpPlans.sort((a, b) => {
      let priorityDiff = (parseFloat(b.priority) || 0) - (parseFloat(a.priority) || 0);
      if (priorityDiff !== 0) return priorityDiff;
      return (parseFloat(b.numberOfMonths) || 0) - (parseFloat(a.numberOfMonths) || 0);
    })[0];
    selectedPlans.push(bestNoDpPlan);
  }
  return selectedPlans;
};

const getWfgFinancePlanInfo = async (orderData) => {

  let finData = {};

  //get finance plan info
  let finPlanRes = await fetch(wfgplansendpoint);
  let finPlanData = await finPlanRes.json();

  let division = orderData.Division.substr(0, 2).toLowerCase();

  let eligiblePlans = finPlanData[`${division}0`];

  longTermFinanceAmt = orderData?.longTermFinanceOption?.financeAmount
    ? orderData?.longTermFinanceOption?.financeAmount
    : 0;
  downPaymentAmt = 0;
  if (longTermFinanceAmt)
    downPaymentAmt = parseFloat(orderData?.longTermFinanceOption?.downPaymentToCollect) || 0;

  // Filter WFG plans and apply business logic
  eligiblePlans = filterWfgPlans(eligiblePlans, orderData);


  eligiblePlans.map((plan) => {
    let code = plan.financeCode.split("|")[0];
    wfgPlans[code] = plan;
  });

console.log(eligiblePlans)

  if (eligiblePlans.length) {
    let selectedPlan = eligiblePlans[0];
    let uvFinancePlan = selectedPlan.financeCode.split("|")[0];
    let encryptedFinancePlans = selectedPlan.encryptedFinanceCodes;
    finData["uvFinancePlan"] = uvFinancePlan;
    finData["encryptedFinancePlans"] = encryptedFinancePlans;
    finData["siteFriendlyLabel"] = selectedPlan.siteFriendlyLabel;
    finData["promoMessage"] = selectedPlan.promoMessage;
    finData["promoMessage"] = selectedPlan.promoMessage;
    finData["termsAndConditions"] = selectedPlan.termsAndConditions;
    finData["marketingMessage"] = selectedPlan.marketingMessage;
    finData["shortPromoMessage"] =
      selectedPlan.marketingMessage && selectedPlan.marketingMessage.markdown
        ? selectedPlan.marketingMessage.markdown
        : "";
    console.log(selectedPlan);
    let disclosureData = []; //await getFinanceDisclosure(acct_no, orderData, finData);
    finData["disclosureData"] = disclosureData;
    finData["eligiblePlans"] = eligiblePlans;
    finData["downPaymentAmt"] = downPaymentAmt;
    finData["serviceFinanceCode"] = selectedPlan.serviceFinanceCode;
  }
  availableFinBalance = finData.availableCredit;
  return finData;
};

const showWfgFinancePlans = async (orderData) => {
  let showFinancePlans = true;
  var financeData = await getWfgFinancePlanInfo(orderData);

  if (showFinancePlans) {
    let eligiblePlans = financeData.eligiblePlans;
    let planItem = "";
    eligiblePlans.map((plan) => {
      console.log(plan)
      let notice =
        plan.downPaymentRequired && financeData.downPaymentAmt
          ? `Small down payment required - <br/>$${financeData.downPaymentAmt} (shipping & sales tax).`
          : `No down payment required`;
      planItem += `<label class="plan-row"><input type="radio" name="wfg-plan" class="wfg-plan" data-downpayment="${
        plan.downPaymentRequired
      }" data-enc="${plan.encryptedFinanceCodes}" data-plan="${plan.serviceFinanceCode}" value="${
        plan.financeCode.split("|")[0]
      }" ${eligiblePlans.length == 1 ? "checked" : ""} /><div>${
        plan.siteFriendlyLabel
      }<div class="notice">${notice}<br/></div></div></label>`;
      //planItem += `<div class="plan-${plan.financeCode.split("|")[0]} promo-collapse collapsed"><div class="content-inner">${document.querySelector(".promo-modal").innerHTML =
      //plan?.promoMessage?.childMarkdownRemark?.html}</div></div>`
    });
    //planItem += `<div class="button-row"><button id="plan-select-btn" class="plan-select-btn primary">Submit</button><button class="plan-cancel-btn">Cancel</button></div>`;
    document.querySelector(".wfg-plans").innerHTML = planItem;
    //document.querySelector(".loading-icon").classList.add("hide");
    //document.querySelector(".long-term-plans").classList.remove("hide");
    //document.querySelector(".modal-holder").classList.remove("hide");
    //document.querySelector(".modal").classList.remove("hide");


    if (eligiblePlans.length == 1)
      document.querySelector('input[name="wfg-plan"]').click();


  }


};


const checkTokenStatusMethod = async () => {
  document.querySelector("section.review-payment .errors").innerHTML = "";
  document.querySelector(".finance-errors").innerHTML = "";
  document.querySelector(".balance-applied").innerHTML = "";
  const order = rtgOrderData; //getOrder()
  var {
    clientToken,
    processInd,
    currentTotal,
    approvedApply,
    clientFirstName,
    clientLastName,
  } = digiBuyState;
  currentTotal = parseFloat(getTotalBalance(order));
  var clientTokenSatus = await fetchClientTokenStatus({
    userToken: clientToken,
  });

  //  .then(async clientTokenSatus => {
  if (clientTokenSatus.StatusCode === "000") {
    // Authorization Approved / Purchase Success
    processPaymentModal();
    updateAddressMethod(clientTokenSatus);

  } else if (clientTokenSatus.StatusCode === "033") {
    // Customer Approval Success
    processPaymentModal();
    updateAddressMethod(clientTokenSatus);
    //this.paymentSessionTimeout(order)
  } else if (
    clientTokenSatus.StatusCode === "100" ||
    clientTokenSatus.StatusCode === "001"
  ) {
    // Customer Terminated (100) or Authorization Declined (001)
    if (clientTokenSatus.OpenToBuyAmount) {
      // Check for openToBuyAmount credit
      const openToBuyAmount = formatNumber(clientTokenSatus.OpenToBuyAmount);
      console.log('opento buy',openToBuyAmount)
      if (openToBuyAmount > 0 && openToBuyAmount < currentTotal) {
        updateModalInfo(openToBuyAmount);
      } else if (openToBuyAmount <= 0) {
        // cancel / denied credit limit increase request
        resetClientToken(
          "You do not have enough available credit limit, please try another payment."
        );
      } else if (clientTokenSatus.StatusCode === "100") {
        resetClientToken(false);
      } else {
        updateModalInfo();
      }
    } else if (processInd === 2) {
      resetClientToken();
    } else {
      resetClientToken(false);
    }
  } else if (
    clientTokenSatus.StatusCode === "002" ||
    clientTokenSatus.StatusCode === "003"
  ) {
    // Account Authentication Success (002, 003)
    updatePayerInfo(clientTokenSatus);

    if (clientTokenSatus.Address1) {
      // CVV verification passed
      updateOrderInfo(order, clientFirstName, clientLastName, clientTokenSatus);
      console.log("digi state");
      console.log(digiBuyState);
      if (clientTokenSatus.OpenToBuyAmount) {
        // Check for openToBuyAmount credit
        const openToBuyAmount = formatNumber(clientTokenSatus.OpenToBuyAmount);
        console.log(openToBuyAmount);
        if (openToBuyAmount > 0 && openToBuyAmount < currentTotal) {
          updateModalInfo(openToBuyAmount);
        } else if (openToBuyAmount <= 0) {
          // request credit limit increase
          updateModalInfo();
        } else {
          updateModalInfo();

          updateAddressMethod(clientTokenSatus);
        }
      } else {
        updateModalInfo();
      }
    } else {
      resetClientToken("Please verify the card CVV code and try again.");
    }
  } else if (clientTokenSatus.StatusCode === "404") {
    // Transaction Failed (Token Expired Scenario)
    resetClientToken("Token expired. Please refresh page and try again.");
  } else if (clientTokenSatus.StatusCode === "401") {
    // Transaction Failed (Token Expired Scenario)
    resetClientToken("Your payment session has expired, please try again.");
  } else if (clientTokenSatus.StatusCode === "403") {
    // Address verification check Fail
    if (clientTokenSatus.Address1) {
      updateOrderInfo(order, clientFirstName, clientLastName, clientTokenSatus);
      if (digiBuyState.approvedApply) {
        digiBuyState.approvedApply = false;
        updateModalInfo();
      } else {
        resetClientToken(
          "Please add or verify the card billing address and try again."
        );
      }
    } else {
      resetClientToken(
        "Please add or verify the card billing address and try again."
      );
    }
  } else if (clientTokenSatus.StatusCode === "00") {
    // eApply_Transaction Approved
    updatePayerInfo(clientTokenSatus);
    if (clientTokenSatus.Address1) {
      updateOrderInfo(order, clientFirstName, clientLastName, clientTokenSatus);
    }

    digiBuyState.approvedApply = true;
    updateModalInfo();
  } else if (clientTokenSatus.StatusCode === "07") {
    // eApply_Transaction Declined
    resetClientToken(
      `Your application has been declined, please try another payment.`
    );
  } else if (clientTokenSatus.StatusCode === "503") {
    // SERVICE UNAVAILABLE
    resetClientToken("Digital Buy - SERVICE UNAVAILABLE 503!");
    console.log("Digital Buy - SERVICE UNAVAILABLE 503!");
  } else {
    resetClientToken("There was a problem with your account");
  }

  //this.setState({ clicked: false })
  window.removeEventListener("message", this.messageEvent);
};

const processPaymentModal = () => {
  //set state here
  let totalBalance = parseFloat(getTotalBalance(rtgOrderData));
  console.log(totalBalance);
  console.log('currenttotal',digiBuyState.currentTotal)
  updateAmounts(rtgOrderData);
  //document.querySelector("#synchrony-remove-btn").classList.remove("hide");
  if (
    longTermFinanceAmt &&
    downPaymentAmt > 0 &&
    selectedPlan.downPaymentRequired
  ) {
    let remainingBalance = totalBalance - downPaymentAmt;
    showFinanceApplied(remainingBalance, downPaymentAmt, selectedPlan.siteFriendlyLabel, selectedPlan);

    pay_toggle("cc");
    document.querySelector(
      ".review-payment .line-item.finance-applied .amt"
    ).innerText = "$" + parseFloat(totalBalance - downPaymentAmt).toFixed(2);
    document
      .querySelector(".review-payment .line-item.finance-applied")
      .classList.remove("hide");
  } else if (digiBuyState.currentTotal < totalBalance && digiBuyState.currentTotal > 0) {
    let remainingBalance = totalBalance - digiBuyState.currentTotal;
    showFinanceApplied(digiBuyState.currentTotal, remainingBalance, selectedPlan.siteFriendlyLabel, selectedPlan);

    pay_toggle("cc");
    document.querySelector(
      ".review-payment .line-item.finance-applied .amt"
    ).innerText = "$" + parseFloat(digiBuyState.currentTotal).toFixed(2);
    document
      .querySelector(".review-payment .line-item.finance-applied")
      .classList.remove("hide");
  }
   else {
     console.log(digiBuyState)
     document.querySelector(".review-payment .line-item.finance-applied .amt").innerText = "$" + parseFloat(totalBalance).toFixed(2);
    document.querySelector(".review-payment .line-item.finance-applied").classList.remove("hide");
    document.querySelector(".review-payment .row").classList.remove("hide"); /*makes step 4 visible*/
    showFinanceApplied(totalBalance, 0, selectedPlan.siteFriendlyLabel, selectedPlan);

    scrollToReview();
  }
};

const showFinanceApplied = (appliedBalance, remainingBalance, labelTxt, selectedPlan) => {
  document
      .querySelector(".balance-applied")
      .insertAdjacentHTML(
        "afterbegin",
        `<div class="financing-applied">
          <div class="fin-content">
            <img src="images/green-check.svg" /><p class="fin-applied">Financing Applied $${parseFloat(appliedBalance).toFixed(2)}<span class="finance-plan">${labelTxt}</span></p>
          </div>
          <button class="remove-financing">Remove</button>
        </div>
        ${remainingBalance > 0 ? `<div class="remaining-balance">Remaining Balance Due: $${parseFloat(remainingBalance).toFixed(2)}<span class="pay-note">Pay remaining balance with credit/debit card</span></div>` : ''}
        `
      );
}

const formatNumber = (num) => {
  return num.replace(",", "");
};

const resetClientToken = (msg) => {
  digiBuyState.clientToken = null;
  digiBuyState.processInd = 1;
  if (msg && msg !== false) {
    document.querySelector("section.review-payment .errors").innerHTML = "";
    document.querySelector(".pp-errors").innerHTML = "";
    document.querySelector(".balance-applied").innerHTML = "";
    document
      .querySelector(".pp-errors")
      .insertAdjacentHTML("afterbegin", `<p class="">${msg}</p>`);
  }
  updateDigibuyForm(rtgOrderData);
  if (document.getElementById("dbuymodal2")) {
    document.getElementById("dbuymodal2").remove();
  }

  closeFinanceModal()
  return false;
};

const closeFinanceModal = () => {
  if (document.getElementById("dbuymodal2")) {
    document.getElementById("dbuymodal2").remove();
  }
}

const updateModalInfo = (openToBuyAmount) => {
  if (openToBuyAmount)
    digiBuyState.currentTotal = openToBuyAmount;
  digiBuyState.processInd = 2;
  updateDigibuyForm(rtgOrderData);

  document.querySelector('input[name="long-term-plan"]:checked').click();
  openModal("dbuyform3");
};

const updatePayerInfo = (clientTokenSatus) => {
  if (clientTokenSatus.FirstName && clientTokenSatus.LastName) {
    digiBuyState.clientFirstName = clientTokenSatus.FirstName;
    digiBuyState.clientTokenSatus = clientTokenSatus.LastName;
  }
  if (clientTokenSatus.AccountNumber) {
    digiBuyState.accountNumber = clientTokenSatus.AccountNumber;
  }
};

const updateOrderInfo = async (
  order,
  clientFirstName,
  clientLastName,
  clientTokenSatus
) => {
  digiBuyState.payerInfo = {
    payer: {
      ...order.payer,
      firstName: clientTokenSatus.FirstName || clientFirstName,
      lastName: clientTokenSatus.LastName || clientLastName,
      email: order.EmailAddress,
      phone: order.PhoneNumber,
      billingDifferent: true,
      billingSubmitted: true,
    },
    billingAddress: {
      ...order.BillingAddress,
      Address1: clientTokenSatus.Address1,
      Address2: clientTokenSatus.Address2,
      City: clientTokenSatus.City,
      State: clientTokenSatus.State,
      ZipCode: formatZip(clientTokenSatus.ZipCode),
      //...this.updateBillingAddress(clientTokenSatus),
    },
  };
};

const updateAddressMethod = (clientTokenSatus) => {
  //const order = getOrder()
  // order.selectedPaymentType = 'Rooms To Go'
  // order.payer = {
  //   ...order.payer,
  //   firstName: order.contact.firstName,
  //   lastName: order.contact.lastName,
  //   email: order.contact.email,
  //   phone: order.contact.phone,
  // }
  // order.billingAddress = {
  //   ...order.ShippingAddress,
  // }
};

const loadApplePay = async (orderData) => {
  console.log("load apple pay");

  let applepay_amt = parseFloat(
    getTotalBalance(orderData) - finAuthAmt - genesisAuthAmt - wfgFinAuthAmt
  ).toFixed(2);
  if (ccAuthAmt > 0) applepay_amt = 0;

  if (longTermFinanceAmt > 0 && downPaymentAmt > 0)
    applepay_amt = downPaymentAmt;

  appleAuthAmt = applepay_amt;
  console.log(appleAuthAmt);

  let appleEnabled = applePayEnabled();

  /*if(document.querySelector('input[name="pay-amount"]:checked').value == 'other' && (parseFloat(getTotalBalance(orderData)) < 20 || parseFloat(document.querySelector('input[name="other-amt"]').value) <20  || document.querySelector('input[name="other-amt"]').value == '')) {
		document.querySelector('.cc-errors').innerHTML = '';
		document.querySelector('.cc-errors').insertAdjacentHTML('afterbegin', `<p class="">Minimum partial payment is $20</p>`);
		document.querySelector('.apple-pay.ppl').classList.add('disabled');
		return false;
	}
	if(availableFinBalance && finAuthAmt > 0 && availableFinBalance >= getTotalBalance(orderData)){
		return false;
	}
	if(document.getElementById('flexresponse').value !== ''){
		return false;
	}*/

  if (!appleEnabled) return false;

  document.querySelector(".options .apple").classList.remove("hide");
  console.log("Apple Pay Enabled");
  document.querySelector(".options .apple-pay").classList.remove("hide");
  const rtgOrder = "Roomstogo Furniture Order";

  const paymentRequest = {
    countryCode: "US",
    currencyCode: "USD",
    supportedNetworks: ["visa", "masterCard", "amex"],
    merchantCapabilities: ["supports3DS"],
    total: { label: rtgOrder, amount: appleAuthAmt },
    requiredBillingContactFields: ["postalAddress"],
  };

  session = new window.ApplePaySession(1, paymentRequest);

  session.onvalidatemerchant = (event) => {
    const { validationURL } = event;

    console.log(event);
    let storeCart =
    onlineStores.includes(orderData?.StoreNumber?.toString())
        ? false
        : true;

    fetch(`${APPLEPAY_URL}`, {
      body: JSON.stringify({
        url: "https://apple-pay-gateway-cert.apple.com/paymentservices/startSession", //validationURL,
        initiativeContext: window.location.hostname,
        storeCart,
      }),
      headers: {
        "Content-Type": "application/json",
      },
      method: "POST",
    })
      .then((response) => response.json())
      .then(async (json) => {
        console.log(json);
        session.completeMerchantValidation(json);
      })
      .catch((error) => {
        console.log(`Unable to validate merchantSession - ${error}`);
        alert("We're unable to process this payment, please try again.");
      });
  };

  session.onpaymentauthorized = async (event) => {
    const { payment } = event;
    console.log("on payment");
    console.log(payment);
    const sc = payment.shippingContact;
    const bc = payment.billingContact;
    const tok = payment.token;

    console.log(payment);
    appleOrderData = tok;
    //appleOrderData = {};
    //session.completePayment(window.ApplePaySession.STATUS_SUCCESS)
    //session.completePayment(window.ApplePaySession.STATUS_FAILURE)

    //hide gift card option
    document.querySelector(".options .gift-card").classList.add("hide");

    document.getElementById("apple_response").value = JSON.stringify(tok);
    document.querySelector(
      ".review-payment .line-item.apple-applied .amt"
    ).innerText = "$" + parseFloat(appleAuthAmt).toFixed(2);
    document
      .querySelector(".review-payment .line-item.apple-applied")
      .classList.remove("hide");
    document.querySelector(".other-amt").disabled = true;
    document
      .querySelector(".review-payment .row")
      .classList.remove("hide"); /*makes step 4 visible*/
    document.querySelector(".apple-box-success").classList.remove("hide");
    session.completePayment(window.ApplePaySession.STATUS_SUCCESS);
    scrollToReview();
  };

  session.begin();
};



const checkMinPayment = () => {
  if(document.querySelector('input[name="pay-amount"]:checked').value == 'other' && (parseFloat(getTotalBalance(rtgOrderData)) < 20 || parseFloat(document.querySelector('input[name="other-amt"]').value) <20)){
    alert('Minimum partial payment is $20');
    return false;
  }
  else
    return true;
}



const applePayEnabled = () => {
  if (
    typeof window !== "undefined" &&
    window.location.protocol === "https:" &&
    window.ApplePaySession
  ) {
    console.log(
      typeof window !== "undefined" &&
        window.location.protocol === "https:" &&
        window.ApplePaySession
    );
    const promise = window.ApplePaySession.canMakePaymentsWithActiveCard(
      APPLE_MERCHANT_IDENTIFIER
    );
    return true; //promise.then(canMakePayments=>canMakePayments);
  }
  return false;
};

const loadPayPalButton = (orderData) => {
  let totalBalance = getTotalBalance(orderData);
  let paypal_amt = parseFloat(
    getTotalBalance(orderData) - finAuthAmt - genesisAuthAmt - giftCardAuthAmt - wfgFinAuthAmt
  ).toFixed(2);

  if (digiBuyState.currentTotal > 0 && digiBuyState.currentTotal < parseFloat(getTotalBalance(orderData))){
    paypal_amt = parseFloat(getTotalBalance(orderData)) - digiBuyState.currentTotal;
    parseFloat(paypal_amt).toFixed(2);

  }

  if (
    longTermFinanceAmt &&
    downPaymentAmt > 0 &&
    selectedPlan.downPaymentRequired
  ) {
    paypal_amt = downPaymentAmt;
  }
  else if (digiBuyState.currentTotal < totalBalance && digiBuyState.currentTotal > 0) {
    paypal_amt = totalBalance - digiBuyState.currentTotal;
  }

  if (ccAuthAmt > 0) paypal_amt = 0;

  document.querySelector("#paypal-button-container").innerHTML = "";
  document.querySelector("button.ppl").classList.add("hide");
  document.querySelector("button.ppl").classList.remove("disabled");
  if (
    document.querySelector('input[name="pay-amount"]:checked').value ==
      "other" &&
    (parseFloat(getTotalBalance(orderData)) < 20 ||
      parseFloat(
        document.querySelector('input[name="other-amt"]').value <= 0
      ) ||
      document.querySelector('input[name="other-amt"]').value == "")
  ) {
    document.querySelector(".cc-errors").innerHTML = "";
    document
      .querySelector(".cc-errors")
      .insertAdjacentHTML(
        "afterbegin",
        `<p class="">Minimum partial payment is $20</p>`
      );
    //return false;
    document.querySelector("button.ppl").classList.add("disabled");
  }

  console.log(paypal_amt);

  if (
    !downPaymentAmt &&
    availableFinBalance &&
    finAuthAmt > 0 &&
    availableFinBalance >= getTotalBalance(orderData)
  ) {
    //document.querySelector('.options .tooltip.fin').classList.remove('hide');
    return false;
  }
  if (document.getElementById("flexresponse").value !== "") {
    //document.querySelector('.options .tooltip.credit').classList.remove('hide');
    return false;
  }
  if (downPaymentAmt && (availableFinBalance || wfgAvailableFinBalance)) paypal_amt = downPaymentAmt;

  ppAuthAmt = paypal_amt;

  paypal
    .Buttons({
      style: {
        layout: "vertical",
        color: "blue",
        shape: "rect",
        label: "paypal",
      },
      createOrder: async function (data, actions) {
        // Set up the transaction
        removeCC();
        //hide gift card option
        let ppObj = {
          "purchase_units": [
              {
                  "amount": {
                      "value": paypal_amt,
                  },
                  "invoice_id": orderData.OrderNumber,
              }
          ],
          "payment_source": {
              "paypal": {
                  "experience_context": {
                      "shipping_preference": "NO_SHIPPING",
                      "user_action": "CONTINUE"
                  }
              }
          }
        };

        let ppRes = await payPalOnCreate(ppObj);
        console.log(ppRes)
        return ppRes.id;
      },
      onApprove: function (data, actions) {
        console.log(data);
        document.querySelector(".options .gift-card").classList.add("hide");
        document.getElementById("paypal_response").value = JSON.stringify(data);
        document.querySelector(
          ".review-payment .line-item.paypal-applied .amt"
        ).innerText = "$" + parseFloat(paypal_amt).toFixed(2);
        document
          .querySelector(".review-payment .line-item.paypal-applied")
          .classList.remove("hide");
        document.querySelector(".other-amt").disabled = true;
        document
          .querySelector(".review-payment .row")
          .classList.remove("hide"); /*makes step 4 visible*/
        document.querySelector(".pp-box-success").classList.remove("hide");
        scrollToReview();

      },
      onError: function (err) {
        // For example, redirect to a specific error page
        alert("There was a problem processing your paypal payment");
      },
    })
    .render("#paypal-button-container");
  document.querySelector("button.ppl").classList.remove("hide");
};

const payPalOnCreate = async (ppObj) => {
  try {
    let action = "/v2/orders";
    let ppRes = await fetch(`${GATSBY_PAYPAL_SERVICE_URL}${action}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(ppObj),
    });
    let ppData = await ppRes.json();
    return ppData;
  }
  catch(e) {
    console.log(e);
    return false;
  }

}

const validateEmail = (email) => {
  let valid = true;
  if (email == "") valid = false;
  if (!/\S+@\S+\.\S+/.test(email)) valid = false;
  return valid;
};

const showPayErrors = (errmsg) => {
  document.querySelector("section.review-payment .errors").innerHTML = "";
  document
    .querySelector("section.review-payment .errors")
    .insertAdjacentHTML("afterbegin", `<p class="error">${errmsg}</p>`);
  document
    .querySelector("section.review-payment .errors")
    .classList.remove("hide");
};

const showErrors = (errmsg) => {
  document.querySelector("section.loading").classList.add("hide");
  document
    .querySelector("section.errors")
    .insertAdjacentHTML("afterbegin", `<p class="error message">${errmsg}</p>`);
  document.querySelector("section.errors").classList.remove("hide");
};

const checkAddress = () => {
  let valid = true;
  document
    .querySelectorAll(
      ".address-section input.required, .address-section select"
    )
    .forEach((el) => {
      if (el.value == "") valid = false;
    });
  return valid;
};

const submitSynchrony = (orderData) => {
  console.log("submit Synchrony");
  console.log(financeData);
  console.log(getTotalBalance(orderData));
  let totalBalance = getTotalBalance(orderData);
  document.querySelector("section.review-payment .errors").innerHTML = "";
  document.querySelector(".finance-errors").innerHTML = "";
  document.querySelector(".balance-applied").innerHTML = "";

  if (
    document.querySelector('input[name="pay-amount"]:checked').value ==
      "other" &&
    (parseFloat(totalBalance) < 20 ||
      parseFloat(
        document.querySelector('input[name="other-amt"]').value <= 0
      ) ||
      document.querySelector('input[name="other-amt"]').value == "")
  ) {
    document
      .querySelector(".finance-errors")
      .insertAdjacentHTML(
        "afterbegin",
        `<p class="">Minimum partial payment is $20</p>`
      );
    return false;
  }

  if (
    document.querySelector('input[name="pay-amount"]:checked').value ==
      "other" &&
    longTermFinanceAmt &&
    selectedPlan.downPaymentRequired
  ) {
    document
      .querySelector(".finance-errors")
      .insertAdjacentHTML(
        "afterbegin",
        `<p class="">Long-term financing can only be applied to full amount</p>`
      );
    return false;
  }

  /*if(!document.querySelector('input[name="payments-chk"]').checked || !document.querySelector('input[name="terms-chk"]').checked) {
		if(!document.querySelector('input[name="payments-chk"]').checked)
			document.querySelector('.finance-errors').insertAdjacentHTML('afterbegin', `<p class="">*You must acknowledge the use of a Rooms To Go Finance Option before continuing</p>`);

		if(!document.querySelector('input[name="terms-chk"]').checked)
			document.querySelector('.finance-errors').insertAdjacentHTML('afterbegin', `<p class="">*You must accept the terms and conditions before continuing.</p>`);
		return false;
	}*/
  if (!financeData || financeData.statusCode !== 200) {
    document
      .querySelector(".finance-errors")
      .insertAdjacentHTML(
        "afterbegin",
        `<p class="">Please check account number and try again</p>`
      );
    return false;
  }
  //hide gift card option
  document.querySelector(".options .gift-card").classList.add("hide");
  document.querySelector(".options .wfgcc").classList.add("hide");

  if (
    longTermFinanceAmt &&
    downPaymentAmt > 0 &&
    selectedPlan.downPaymentRequired
  ) {
    let remainingBalance = totalBalance - downPaymentAmt;
    document
      .querySelector(".balance-applied")
      .insertAdjacentHTML(
        "afterbegin",
        `<p class="">Financing Applied $${parseFloat(remainingBalance).toFixed(
          2
        )}</p><button id="add-cc-btn" class="add-cc-btn">Click Here to Pay remaining $${parseFloat(
          downPaymentAmt
        ).toFixed(2)} with Credit Card</button>`
      );
    pay_toggle("cc");
    document.querySelector(".review-payment .line-item.finance-applied .amt").innerText = "$" + parseFloat(totalBalance - downPaymentAmt).toFixed(2);
    document.querySelector(".review-payment .line-item.finance-applied").classList.remove("hide");
  } else if (
    longTermFinanceAmt &&
    !selectedPlan.downPaymentRequired &&
    financeData.availableCredit >= totalBalance
  ) {
    console.log(longTermFinanceAmt);
    document
      .querySelector(".balance-applied")
      .insertAdjacentHTML(
        "afterbegin",
        `<p class="">Financing Applied $${totalBalance}</p>`
      );
    document.querySelector(".other-amt").disabled = true;
    document
      .querySelector(".review-payment .row")
      .classList.remove("hide"); /*makes step 4 visible*/
    document.querySelector(
      ".review-payment .line-item.finance-applied .amt"
    ).innerText = "$" + totalBalance;
    document
      .querySelector(".review-payment .line-item.finance-applied")
      .classList.remove("hide");
  } else if (financeData.availableCredit < totalBalance) {
    availableFinBalance =
      financeData.availableCredit > longTermFinanceAmt
        ? longTermFinanceAmt
        : financeData.availableCredit;
    let remainingBalance = totalBalance - availableFinBalance;
    //pay_toggle("cc");
    document
      .querySelector(".balance-applied")
      .insertAdjacentHTML(
        "afterbegin",
        `<p class="">Financing Applied $${parseFloat(
          availableFinBalance
        ).toFixed(
          2
        )}</p><button id="add-cc-btn" class="add-cc-btn">Click Here to Pay remaining $${parseFloat(
          remainingBalance
        ).toFixed(2)} with Credit Card</button>`
      );
    //document.querySelector('.totals-sidebar .line-item.finance-applied .amt').innerText = "$"+availableFinBalance;
    document.querySelector(
      ".review-payment .line-item.finance-applied .amt"
    ).innerText = "$" + parseFloat(availableFinBalance).toFixed(2);
    //document.querySelector('.totals-sidebar .line-item.finance-applied').classList.remove('hide');
    document
      .querySelector(".review-payment .line-item.finance-applied")
      .classList.remove("hide");

    /*on reaching review payment step*/
    dataLayer.push({
      event: "paymentReview",
      orderStatus: {
        OrderNumber: orderData.OrderNumber,
        Status: orderData.orderStatus,
        DeliveryDate: orderData.DeliveryDate,
        OrderDate: orderData.OrderDate,
        Balance: orderData.Balance,
        OrderTotal: orderData.OrderTotal,
        Division: orderData.Division,
        premiumDelivery: orderData.upgradeDelivery,
        premiumDeliveryCharge: orderData?.upgradeInfo,
        PaymentType: orderData.PaymentType,
      },
    });

    //document.querySelector('.review-payment .row').classList.remove('hide'); /*makes step 4 visible*/
  } else {
    availableFinBalance = getTotalBalance(orderData);

    /*on reaching review payment step*/
    dataLayer.push({
      event: "paymentReview",
      orderStatus: {
        OrderNumber: orderData.OrderNumber,
        Status: orderData.orderStatus,
        DeliveryDate: orderData.DeliveryDate,
        OrderDate: orderData.OrderDate,
        Balance: orderData.Balance,
        OrderTotal: orderData.OrderTotal,
        Division: orderData.Division,
        premiumDelivery: orderData.upgradeDelivery,
        premiumDeliveryCharge: orderData?.upgradeInfo,
        PaymentType: orderData.PaymentType,
      },
    });
    document
      .querySelector(".balance-applied")
      .insertAdjacentHTML(
        "afterbegin",
        `<p class="">Financing Applied $${availableFinBalance}</p>`
      );
    document.querySelector(".other-amt").disabled = true;
    document
      .querySelector(".review-payment .row")
      .classList.remove("hide"); /*makes step 4 visible*/
    document.querySelector(
      ".review-payment .line-item.finance-applied .amt"
    ).innerText = "$" + availableFinBalance;
    document
      .querySelector(".review-payment .line-item.finance-applied")
      .classList.remove("hide");
  }
  finAuthAmt = availableFinBalance;
  document.querySelector(".genesis-cc").classList.add("hide");
  document.querySelector(".rtgcc-box").classList.add("hide");
  document.querySelector(".rtgcc-box-success").classList.remove("hide");
  loadPayPalButton(orderData);

  scrollToReview();
};

const submitGiftCard = (orderData) => {
  console.log("submit Gift Card");
  console.log(giftCardData);
  console.log(getTotalBalance(orderData));
  let totalBalance = getTotalBalance(orderData);
  document.querySelector("section.review-payment .errors").innerHTML = "";
  document.querySelector(".gift-card-errors").innerHTML = "";
  document.querySelector(".balance-applied").innerHTML = "";

  if (
    document.querySelector('input[name="pay-amount"]:checked').value ==
      "other" &&
    (parseFloat(totalBalance) < 20 ||
      parseFloat(
        document.querySelector('input[name="other-amt"]').value <= 0
      ) ||
      document.querySelector('input[name="other-amt"]').value == "")
  ) {
    document
      .querySelector(".gift-card-errors")
      .insertAdjacentHTML(
        "afterbegin",
        `<p class="">Minimum partial payment is $20</p>`
      );
    return false;
  }

  if (!giftCardData || !giftCardData.giftCardBalance) {
    document
      .querySelector(".gift-card-errors")
      .insertAdjacentHTML(
        "afterbegin",
        `<p class="">Please check account number and try again</p>`
      );
    return false;
  }

  if (giftCardData.giftCardBalance < totalBalance) {
    availableGiftCardBalance = giftCardData.giftCardBalance;
    let remainingBalance = totalBalance - availableGiftCardBalance;
    //pay_toggle("cc");
    //document.querySelector('.balance-applied').insertAdjacentHTML('afterbegin', `<p class="">Gift Card Applied $${parseFloat(availableGiftCardBalance).toFixed(2)}</p><button id="add-cc-btn" class="add-cc-btn">Pay remaining $${parseFloat(remainingBalance).toFixed(2)} with Credit Card</button>`);
    //document.querySelector('.totals-sidebar .line-item.finance-applied .amt').innerText = "$"+availableFinBalance;
    document.querySelector(
      ".review-payment .line-item.gift-card-applied .amt"
    ).innerText = "$" + parseFloat(availableGiftCardBalance).toFixed(2);
    //document.querySelector('.totals-sidebar .line-item.finance-applied').classList.remove('hide');
    document
      .querySelector(".review-payment .line-item.gift-card-applied")
      .classList.remove("hide");

    /*on reaching review payment step*/
    dataLayer.push({
      event: "paymentReview",
      orderStatus: {
        OrderNumber: orderData.OrderNumber,
        Status: orderData.orderStatus,
        DeliveryDate: orderData.DeliveryDate,
        OrderDate: orderData.OrderDate,
        Balance: orderData.Balance,
        OrderTotal: orderData.OrderTotal,
        Division: orderData.Division,
        premiumDelivery: orderData.upgradeDelivery,
        premiumDeliveryCharge: orderData?.upgradeInfo,
        PaymentType: orderData.PaymentType,
      },
    });

    document
      .querySelector(".review-payment .row")
      .classList.remove("hide"); /*makes step 4 visible*/
  } else {
    availableGiftCardBalance = getTotalBalance(orderData);

    /*on reaching review payment step*/
    dataLayer.push({
      event: "paymentReview",
      orderStatus: {
        OrderNumber: orderData.OrderNumber,
        Status: orderData.orderStatus,
        DeliveryDate: orderData.DeliveryDate,
        OrderDate: orderData.OrderDate,
        Balance: orderData.Balance,
        OrderTotal: orderData.OrderTotal,
        Division: orderData.Division,
        premiumDelivery: orderData.upgradeDelivery,
        premiumDeliveryCharge: orderData?.upgradeInfo,
        PaymentType: orderData.PaymentType,
      },
    });
    document
      .querySelector(".balance-applied")
      .insertAdjacentHTML(
        "afterbegin",
        `<p class="">Gift Card  $${availableGiftCardBalance}</p>`
      );
    document.querySelector(".other-amt").disabled = true;
    document
      .querySelector(".review-payment .row")
      .classList.remove("hide"); /*makes step 4 visible*/
    document.querySelector(
      ".review-payment .line-item.gift-card-applied .amt"
    ).innerText = "$" + availableGiftCardBalance;
    document
      .querySelector(".review-payment .line-item.gift-card-applied")
      .classList.remove("hide");
  }
  giftCardAuthAmt = availableGiftCardBalance;
  document.querySelector("#pay-btn .pay-amt").innerText =
    "$" + parseFloat(giftCardAuthAmt).toFixed(2);
  console.log(giftCardAuthAmt);
  if (longTermFinanceAmt > 0 && downPaymentAmt > 0)
    giftCardAuthAmt = downPaymentAmt;
  //loadPayPalButton(orderData);
  document.querySelector("#gift-card-balance-btn").classList.add("hide");
  document.querySelector(".gift-card-box").classList.add("hide");
  document.querySelector(".options .rtgcc").classList.add("hide");
  document.querySelector(".gift-card-box-success").classList.remove("hide");
  scrollToReview();
};

const submitGenesis = (orderData) => {
  console.log("submit Genesis");
  console.log(genesisData);
  console.log(getTotalBalance(orderData));
  let totalBalance = getTotalBalance(orderData);
  document.querySelector("section.review-payment .errors").innerHTML = "";
  document.querySelector(".genesis-errors").innerHTML = "";
  document.querySelector(".balance-applied").innerHTML = "";

  if (
    document.querySelector('input[name="pay-amount"]:checked').value ==
      "other" &&
    (parseFloat(totalBalance) < 20 ||
      parseFloat(
        document.querySelector('input[name="other-amt"]').value <= 0
      ) ||
      document.querySelector('input[name="other-amt"]').value == "")
  ) {
    document
      .querySelector(".genesis-errors")
      .insertAdjacentHTML(
        "afterbegin",
        `<p class="">Minimum partial payment is $20</p>`
      );
    return false;
  }

  if (!document.querySelector('input[name="genesis-terms-chk"]').checked) {
    document
      .querySelector(".genesis-errors")
      .insertAdjacentHTML(
        "afterbegin",
        `<p class="">*You must accept the terms and conditions before continuing.</p>`
      );
    return false;
  }

  if (!genesisData || !genesisData.availableCredit) {
    document
      .querySelector(".genesis-errors")
      .insertAdjacentHTML(
        "afterbegin",
        `<p class="">Please check account number and try again</p>`
      );
    return false;
  }
  //hide gift card option
  document.querySelector(".options .gift-card").classList.add("hide");

  if (genesisData.availableCredit < totalBalance) {
    availableGenesisBalance = genesisData.availableCredit;
    let remainingBalance = totalBalance - availableGenesisBalance;
    //pay_toggle("cc");

    document
      .querySelector(".balance-applied")
      .insertAdjacentHTML(
        "afterbegin",
        `<p class="">Concora Financing Applied $${parseFloat(
          availableGenesisBalance
        ).toFixed(
          2
        )}</p><button id="add-cc-btn" class="add-cc-btn">Click Here to Pay remaining $${parseFloat(
          remainingBalance
        ).toFixed(2)} with Credit Card</button>`
      );
    //document.querySelector('.totals-sidebar .line-item.finance-applied .amt').innerText = "$"+availableFinBalance;
    document.querySelector(
      ".review-payment .line-item.genesis-finance-applied .amt"
    ).innerText = "$" + parseFloat(availableGenesisBalance).toFixed(2);
    //document.querySelector('.totals-sidebar .line-item.finance-applied').classList.remove('hide');
    document
      .querySelector(".review-payment .line-item.genesis-finance-applied")
      .classList.remove("hide");

    /*on reaching review payment step*/
    dataLayer.push({
      event: "paymentReview",
      orderStatus: {
        OrderNumber: orderData.OrderNumber,
        Status: orderData.orderStatus,
        DeliveryDate: orderData.DeliveryDate,
        OrderDate: orderData.OrderDate,
        Balance: orderData.Balance,
        OrderTotal: orderData.OrderTotal,
        Division: orderData.Division,
        premiumDelivery: orderData.upgradeDelivery,
        premiumDeliveryCharge: orderData?.upgradeInfo,
        PaymentType: orderData.PaymentType,
      },
    });

    //document.querySelector('.review-payment .row').classList.remove('hide'); /*makes step 4 visible*/
  } else {
    availableGenesisBalance = getTotalBalance(orderData);

    /*on reaching review payment step*/
    dataLayer.push({
      event: "paymentReview",
      orderStatus: {
        OrderNumber: orderData.OrderNumber,
        Status: orderData.orderStatus,
        DeliveryDate: orderData.DeliveryDate,
        OrderDate: orderData.OrderDate,
        Balance: orderData.Balance,
        OrderTotal: orderData.OrderTotal,
        Division: orderData.Division,
        premiumDelivery: orderData.upgradeDelivery,
        premiumDeliveryCharge: orderData?.upgradeInfo,
        PaymentType: orderData.PaymentType,
      },
    });
    document
      .querySelector(".balance-applied")
      .insertAdjacentHTML(
        "afterbegin",
        `<p class="">Concora Financing  $${availableGenesisBalance}</p>`
      );
    document.querySelector(".other-amt").disabled = true;
    document
      .querySelector(".review-payment .row")
      .classList.remove("hide"); /*makes step 4 visible*/
    document.querySelector(
      ".review-payment .line-item.genesis-finance-applied .amt"
    ).innerText = "$" + availableGenesisBalance;
    document
      .querySelector(".review-payment .line-item.genesis-finance-applied")
      .classList.remove("hide");
  }
  genesisAuthAmt = availableGenesisBalance;
  loadPayPalButton(orderData);

  document.querySelector(".genesis-cc-box").classList.add("hide");
  document.querySelector(".options .rtgcc").classList.add("hide");
  document.querySelector(".genesis-cc-box-success").classList.remove("hide");
  scrollToReview();
};

const getWfgFinanceInfo = async (acct_no, zipcode, orderData) => {
  //let totalBalance = getTotalBalance(orderData);
  let action = "/wfg/balanceInquiry";
  const acctObj = {
    "accountNumber": acct_no,
    "zipcode": zipcode,
    "transactionID": orderData.OrderNumber, //is this needed? is it ordernum?
  };
  let acctRes = await fetch(`${finendpoint}${action}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(acctObj),
  });
  //let finData = await acctRes.json();
  //console.log(finData)

  if (!acctRes || acctRes.status !== 200) {
    document.querySelector('.modal-holder-wfg .loading-icon').classList.add('hide');
    document.querySelector('.modal-holder-wfg .step-1').classList.remove('hide');
    document.querySelector('.modal-holder-wfg .step-2').classList.add('hide');
    document.querySelector('.modal-holder-wfg .step-1 .error').innerHTML = 'There was a problem retrieving account data. Please try again.';
  }
  else {
    let finData = await acctRes.json();


    let acct_key = finData?.accountKey ?? 0;
    let disclosureData = await getWfgFinanceDisclosure(
      acct_key,
      orderData
    );

    finData["disclosureData"] = disclosureData;

    wfgFinAuthAmt = getTotalBalance(orderData) > parseFloat(finData.availableCredit) ? parseFloat(finData.availableCredit) : getTotalBalance(orderData);
    finData['wfgFinAuthAmt'] = wfgFinAuthAmt;

    return finData;
    }
};

const getWfgFinanceDisclosure = async (
  acct_key,
  orderData
) => {
  let action = "/wfg/disclosure";
  const disclosureObj = {
    accountKey: acct_key,
    transactionID: orderData.OrderNumber,
    planNumber: wfgSelectedPlan?.serviceFinanceCode //CHANGE
  };
  let discRes = await fetch(`${finendpoint}${action}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(disclosureObj),
  });
  if(discRes && discRes.status !== 200)
    return false;
  let discData = await discRes.json();
  return discData;
};


const getFinanceInfo = async (acct_no, zipcode, orderData) => {
  //let totalBalance = getTotalBalance(orderData);
  let action = "/synchrony/balanceInquiry";
  const acctObj = {
    accountNumber: acct_no,
    //"zipcode": orderData.DeliveryAddress.Zip,
    transactionID: "", //is this needed? is it ordernum?
  };
  let acctRes = await fetch(`${finendpoint}${action}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(acctObj),
  });
  let finData = await acctRes.json();

  //get finance plan info
  let finPlanRes = await fetch(financeplansendpointadmin);
  let finPlanData = await finPlanRes.json();

  let division = orderData.Division.substr(0, 2).toLowerCase();

  let eligiblePlans = finPlanData[`${division}0`];
  longTermFinanceAmt = orderData.longTermFinanceOption?.financeAmount
    ? orderData.longTermFinanceOption?.financeAmount
    : 0;
  downPaymentAmt = 0;
  if (longTermFinanceAmt) {
    downPaymentAmt = parseFloat(
      orderData.longTermFinanceOption.downPaymentToCollect
    );
    eligiblePlans = eligiblePlans.filter(
      (p) =>
        p.name !== "GENESIS" &&
        p.name !== "Genesis" /*&& p.downPaymentRequired == true*/ &&
        p.threshold < getTotalBalance(orderData)
    );
    let inStoreDeposits = 0;
    if (
      orderData.Deposits &&
      orderData.Deposits.Deposit &&
      orderData.Deposits.Deposit.length
    )
      inStoreDeposits = parseFloat(
        orderData.Deposits.Deposit[0].AuthorizedAmount
      );

    let downpaymentPlans = eligiblePlans
      .filter((p) => p.downPaymentRequired == true)
      .sort(function (a, b) {
        return a.priority - b.priority;
      });
    let noDownpaymentPlans = eligiblePlans.filter(
      (p) => p.downPaymentRequired == false
    );
    downpaymentPlans = [downpaymentPlans[0]];

    eligiblePlans = downpaymentPlans.concat(noDownpaymentPlans);

    eligiblePlans.map((plan) => {
      let code = plan?.financeCode.split("|")[0];
      longTermPlans[code] = plan;
    });
  } else {
    eligiblePlans = eligiblePlans.filter(
      (p) =>
        p.name !== "GENESIS" &&
        p.name !== "Genesis" &&
        p.downPaymentRequired == false &&
        p.threshold < getTotalBalance(orderData)
    );
  }


  if (eligiblePlans.length) {
    let selectedPlan = eligiblePlans[0];
    let uvFinancePlan = selectedPlan.financeCode.split("|")[0];
    let encryptedFinancePlans = selectedPlan.encryptedFinanceCodes;
    finData["uvFinancePlan"] = uvFinancePlan;
    finData["encryptedFinancePlans"] = encryptedFinancePlans;
    finData["siteFriendlyLabel"] = selectedPlan.siteFriendlyLabel;
    finData["promoMessage"] = selectedPlan.promoMessage;
    finData["promoMessage"] = selectedPlan.promoMessage;
    finData["termsAndConditions"] = selectedPlan.termsAndConditions;
    finData["marketingMessage"] = selectedPlan.marketingMessage;
    finData["shortPromoMessage"] =
      selectedPlan.marketingMessage && selectedPlan.marketingMessage.markdown
        ? selectedPlan.marketingMessage.markdown
        : "";
    console.log(selectedPlan);
    let disclosureData = await getFinanceDisclosure(
      acct_no,
      orderData,
      finData
    );
    finData["disclosureData"] = disclosureData;
    finData["eligiblePlans"] = eligiblePlans;
    finData["downPaymentAmt"] = downPaymentAmt;
  }
  availableFinBalance = finData.availableCredit;
  return finData;
};

const getFinanceDisclosure = async (
  acct_no,
  orderData,
  finData,
  pdf = false
) => {
  let action = "/synchrony/disclosure";
  const disclosureObj = {
    accountNumber: acct_no,
    authorizationAmount: parseFloat(getTotalBalance(orderData)),
    encryptedFinancePlan: finData["encryptedFinancePlans"],
    uvFinancePlan: finData["uvFinancePlan"],
    pdf: pdf,
  };
  let discRes = await fetch(`${finendpoint}${action}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(disclosureObj),
  });
  let discData = await discRes.json();
  return discData;
};

const getGiftCardInfo = async (acct_no, pin, orderData) => {
  let action = "/balanceInquiry";
  const acctObj = {
    cardNumber: acct_no,
    pin: pin,
  };
  let acctRes = await fetch(`${GIFT_CARD_URL}${action}?cardNumber=${acct_no}&pin=${pin}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "authtoken": grecaptcha.getResponse()
    },
    //body: JSON.stringify(acctObj),
  });
  let finData = await acctRes.json();
  console.log(finData);
  availableGiftCardBalance = finData.giftCardBalance;
  return finData;
};

const getGenesisInfo = async (acct_no, phone, orderData) => {
  let action = "/genesis/balanceInquiry";
  const acctObj = {
    accountNumber: acct_no,
    phoneNumber: phone,
    transactionID: "", //is this needed? is it ordernum?
  };
  let acctRes = await fetch(`${finendpoint}${action}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(acctObj),
  });
  let finData = await acctRes.json();

  availableGenesisBalance = finData.availableCredit;
  return finData;
};

const getTotalBalance = (orderData, includeUpgrade = true) => {
  let OrderTotal = orderData?.OrderTotal;
  let Balance = orderData?.Balance;
  let upgradeAmount = orderData?.upgradeInfo ? orderData?.upgradeInfo.total : 0;

  if (Balance >= 100) {
    if (
      document.querySelector('input[name="pay-amount"][value="other"]') &&
      document.querySelector('input[name="pay-amount"][value="other"]')
        .checked &&
      parseFloat(document.querySelector('input[name="other-amt"]').value) <
        Balance
    ) {
      Balance =
        parseFloat(document.querySelector('input[name="other-amt"]').value) ||
        0;
    }
  }

  if (
    typeof document.getElementById("upgrade") != "undefined" &&
    document.getElementById("upgrade") != null &&
    document.getElementById("upgrade").checked &&
    parseFloat(Balance) < 0.1
  )
    Balance = 0;

  if (
    typeof document.getElementById("upgrade") != "undefined" &&
    document.getElementById("upgrade") != null &&
    document.getElementById("upgrade").checked &&
    includeUpgrade
  ) {
    Balance = parseFloat(Balance) + parseFloat(upgradeAmount);
  }

  return parseFloat(Balance).toFixed(2);
};

const updateAmounts = (orderData) => {
  let OrderTotal = orderData.OrderTotal;

  let mattressBalance = parseFloat(orderData?.mattressBalance) || 0;
  let Balance = parseFloat(orderData.Balance || 0) + mattressBalance;
  let OgBalance = orderData.Balance //- mattressBalance;
  let PayBalance = orderData.Balance;
  let BtnPayBalance = orderData.Balance;
  let paidAmount = orderData?.originalBalance != null ? orderData?.originalBalance : Balance;
  let PaymentsApplied = parseFloat(OrderTotal - parseFloat(paidAmount));
  let upgradeAmount = orderData.upgradeInfo ? orderData.upgradeInfo.total : 0;
  let TaxAmount = parseFloat(orderData.TaxAmount);
  let DeliveryCharge = parseFloat(orderData.DeliveryCharge);
  let RemainingBalance = parseFloat(orderData.OrderTotal) - PaymentsApplied;
  let NewTax = parseFloat(orderData.newTax) || 0;

  document.querySelector('.orderinfo .line-item.tax').classList.add('hide');
  document.querySelector(".cc-errors").innerHTML = "";
  document
    .querySelector(".review-payment .line-item.premium-delivery")
    .classList.add("hide");

  if (
    Balance >=
    100 /* && orderData.StoreNumber != 970 && orderData.StoreNumber != 980 */
  ) {
    document
      .querySelector(".pay-amount-select .col.other")
      .classList.remove("hide");

    if (
      document.querySelector('input[name="pay-amount"][value="other"]') &&
      document.querySelector('input[name="pay-amount"][value="other"]').checked
    ) {
      Balance =
        parseFloat(document.querySelector('input[name="other-amt"]').value) ||
        0;
      BtnPayBalance = parseFloat(document.querySelector('input[name="other-amt"]').value) || 0;
    }
  }

  if (
    typeof document.getElementById("upgrade") != "undefined" &&
    document.getElementById("upgrade") != null &&
    document.getElementById("upgrade").checked &&
    parseFloat(Balance) < 0.1
  ) {
    Balance = 0;
    PayBalance = 0;
    BtnPayBalance = 0;
  }

  if (
    document.getElementById("upgrade") &&
    document.getElementById("upgrade").checked
  ) {
    Balance = parseFloat(Balance) + parseFloat(upgradeAmount);
    PayBalance = parseFloat(PayBalance) + parseFloat(upgradeAmount);
    BtnPayBalance = parseFloat(BtnPayBalance) + parseFloat(upgradeAmount);
  }

  if (
    parseFloat(OgBalance) > 0.1 ||
    (document.getElementById("upgrade") &&
      document.getElementById("upgrade").checked)
  ) {
    document
      .querySelector(".order-section.payment .row")
      .classList.remove("hide");
  } else {
    document.querySelector(".order-section.payment .row").classList.add("hide");
  }

  //if(OgBalance > 0)
  document.querySelector(".pay-amount-select .pay-amt").innerText =
    "$" + parseFloat(PayBalance).toFixed(2);

  /*Order information*/
  document.querySelector(".orderinfo .line-item .amt").innerText =
    "$" + parseFloat(OrderTotal).toFixed(2);
  document.querySelector(".orderinfo .line-item.payments .amt").innerText =
    "$" + parseFloat(PaymentsApplied).toFixed(2);
  document.querySelector(".orderinfo .line-item.balance .amt").innerText =
    "$" + parseFloat(OgBalance - NewTax).toFixed(2);
  document.querySelector(".orderinfo .line-item.balance-tax .amt").innerText =
    "$" + parseFloat(NewTax).toFixed(2);
  document.querySelector(".orderinfo .line-item.balance-total .amt").innerText =
    "$" + parseFloat(OgBalance).toFixed(2);

  /*if(TaxAmount > 0){
    document.querySelector('.orderinfo .line-item.tax .amt').innerText = `$${TaxAmount.toFixed(2)}`;
    document.querySelector('.orderinfo .line-item.tax').classList.remove('hide');
  }*/
  if(orderData.DeliveryCharge != null && orderData.mattressBalance){
    //document.querySelector('.orderinfo .line-item.delivery .amt').innerText = `$${parseFloat(DeliveryCharge).toFixed(2)}`;
    //document.querySelector('.orderinfo .line-item.delivery').classList.remove('hide');
  }
  if(NewTax){
    document.querySelector('.orderinfo .line-item.balance-tax').classList.remove('hide');
    document.querySelector('.orderinfo .line-item.balance-total').classList.remove('hide');
  }

  /*Sidebar*/
  /* document.querySelector('.totals-sidebar .line-item .amt').innerText = "$"+OrderTotal;
	document.querySelector('.totals-sidebar .line-item.payments .amt').innerText = "$"+PaymentsApplied.toFixed(2);
	document.querySelector('.totals-sidebar .line-item.balance .amt').innerText = "$"+Balance; */

  /*Review Payment information*/
  document.querySelector(".review-payment .line-item.subtotal .amt").innerText =
    "$" + parseFloat(orderData.subTotal).toFixed(2);
  document.querySelector(".review-payment .line-item.taxes .amt").innerText =
    "$" + parseFloat(TaxAmount).toFixed(2);
  document.querySelector(
    ".review-payment .line-item.order-balance .amt"
  ).innerText = "$" + parseFloat(RemainingBalance).toFixed(2);
  if(mattressBalance > 0)
    document.querySelector(".review-payment .line-item.order-balance .amt").innerText = "$" + parseFloat(mattressBalance).toFixed(2);

  document.querySelector(
    ".review-payment .line-item.order-total .amt"
  ).innerText = "$" + parseFloat(OrderTotal).toFixed(2);

  if (
    typeof document.getElementById("upgrade") != "undefined" &&
    document.getElementById("upgrade") != null &&
    document.getElementById("upgrade").checked
  ) {
    document.querySelector(
      ".review-payment .line-item.premium-delivery .amt"
    ).innerText = "$" + parseFloat(upgradeAmount).toFixed(2);
    document
      .querySelector(".review-payment .line-item.premium-delivery")
      .classList.remove("hide");
  }
  document.querySelector(".review-payment .line-item.payments .amt").innerText =
    "-$" + parseFloat(PaymentsApplied).toFixed(2);
  document.querySelector(".review-payment .line-item.balance .amt").innerText =
    "$" + parseFloat(Balance).toFixed(2);
  document.querySelector(".review-payment button .pay-amt").innerText =
    "$" + parseFloat(BtnPayBalance).toFixed(2);

  document.querySelector(".apple-pay").classList.remove("disabled");
  if (
    document.querySelector('input[name="pay-amount"]:checked').value ==
      "other" &&
    (parseFloat(getTotalBalance(orderData)) < 20 ||
      parseFloat(document.querySelector('input[name="other-amt"]').value) <
        20 ||
      document.querySelector('input[name="other-amt"]').value == "")
  ) {
    document.querySelector(".apple-pay").classList.add("disabled");
  }
  if (
    availableFinBalance &&
    finAuthAmt > 0 &&
    availableFinBalance >= getTotalBalance(orderData)
  ) {
    document.querySelector(".apple-pay").classList.add("disabled");
  }
  if (document.getElementById("flexresponse").value !== "") {
    document.querySelector(".apple-pay").classList.add("disabled");
  }
  loadPayPalButton(orderData);
  //loadApplePay(orderData);
};

const toggleAddress = (ischecked) => {

  if (!ischecked) {
    document.querySelector(".address-section").classList.remove("hide");
  } else {
    document.querySelector(".address-section").classList.add("hide");
  }
};

const scrollToSection = (sel) => {
  const y =
    document.querySelector(sel).getBoundingClientRect().top +
    window.scrollY;
  window.scroll({
    top: y,
    behavior: "smooth",
  });
};

const scrollToReview = () => {
  const y =
    document.querySelector(".review-payment").getBoundingClientRect().top +
    window.scrollY;
  window.scroll({
    top: y,
    behavior: "smooth",
  });
  dataLayer.push({
    event: "ee_checkout_option",
    ecommerce: {
      checkout_option: {
        step: 4,
      },
    },
  });
};

const scrollToTop = () => {
  window.scroll({
    top: 0,
    behavior: "smooth",
  });
};

const buildInterface = async (orderData) => {
  /*flags*/
  let showPayonline = orderData.showPayonline;
  let DoorwayDelivery = orderData.DoorwayDelivery;
  let upgradeDelivery = orderData.upgradeDelivery;
  let deliveryType = orderData.DeliveryType;
  let upgradeAmount = orderData.upgradeInfo ? orderData.upgradeInfo.total : 0;
  let StoreNumber = orderData.StoreNumber;

  /*order data*/
  let OrderNumber = orderData.OrderNumber;
  let OrderTotal = orderData.OrderTotal;
  let Balance = orderData.Balance || 0;
  let PaymentsApplied = parseFloat(OrderTotal - Balance);

  /*delivery data*/
  let Del_Address1 = orderData.DeliveryAddress.Address1.toLowerCase();
  let Del_Address2 = orderData.DeliveryAddress.Address2.toLowerCase();
  let Del_City = orderData.DeliveryAddress.City.toLowerCase();
  let Del_State = orderData.DeliveryAddress.State;
  let Del_Zip = orderData.DeliveryAddress.Zip;
  let Status = orderData.Status;

  let FinancePlan = orderData.FinancePlan;
  let FinDeposits = orderData.FinDeposits || 0;

  /*Set up Terms and condition and warranty links*/
  let tocLink = "https://legal.roomstogo.com/rtg-online#contract-vnmnsf90p";
  if (onlineStores.includes(StoreNumber?.toString()))
    tocLink = "https://legal.roomstogo.com/rtg-online#contract-h1qbyyz5u";
  else document.querySelector(".store-notice").classList.remove("hide"); //document.querySelector('.consent').classList.remove('hide');

  document.querySelector(".read-terms a").href = tocLink;

  let hasESC = false;
  let ESCLink = "";
  let ESCProvider = "";
  let ESCPlan = "";
  if (orderData.LineItems && orderData.LineItems.LineItem.length > 0) {
    for (let i = 0; i < orderData.LineItems.LineItem.length; i++) {
      let item = orderData.LineItems.LineItem[i];
      if (item.ESCLink && item.ESCLink !== "") {
        hasESC = true;
        ESCLink = item.ESCLink;
        ESCProvider = item.ESCProvider;
        ESCPlan = item.ESCPlan;
      }
      if (item.ChildItems && item.ChildItems.LineItem.length > 0) {
        for (let i = 0; i < item.ChildItems.LineItem.length; i++) {
          let child = item.ChildItems.LineItem[i];
          if (child.ESCLink && child.ESCLink !== "") {
            hasESC = true;
            ESCLink = child.ESCLink;
            ESCProvider = child.ESCProvider;
            ESCPlan = child.ESCPlan;
          }
        }
      }
    }
  }
  if (hasESC && ESCLink !== "") {
    if (ESCProvider == "FORTEGRA") {
      if (ESCPlan == "RTGLOSADJBEDI7YD") {
        document
          .querySelector(".adjustable-base-plan")
          .classList.remove("hide");
        document.querySelector(".adjustable-base-plan a").href = ESCLink;
        document.querySelector(".adjustable-base-plan a").innerHTML =
          "Lifestyle Adjustable Base Service Contract by Fortegra";
      } else {
        document.querySelector(".protection-plan").classList.remove("hide");
        document.querySelector(".protection-plan a").href = ESCLink;
        document.querySelector(".protection-plan p strong").innerHTML =
          "Furniture Service Contract";
        document.querySelector(".protection-plan span.plan").innerHTML =
          "my Service Contract";
        document.querySelector(".protection-plan a").innerHTML =
          "Guard It Service Contract - Furniture (Includes Dispute Resolution/Arbitration Agreement and Class Action Waiver)";
      }
    } else {
      if (ESCPlan == "R7ABA") {
        document
          .querySelector(".adjustable-base-plan")
          .classList.remove("hide");
        document.querySelector(".adjustable-base-plan a").href = ESCLink;
        document.querySelector(".adjustable-base-plan a").innerHTML =
          "Lifestyle Adjustable Base Protection Plan by Guardian";
      } else {
        document.querySelector(".protection-plan").classList.remove("hide");
        document.querySelector(".protection-plan a").href = ESCLink;
        document.querySelector(".protection-plan p strong").innerHTML =
          "Furniture Protection Plan";
        document.querySelector(".protection-plan span.plan").innerHTML =
          "my Protection Plan";
        document.querySelector(".protection-plan a").innerHTML =
          "Guard It Residential Furniture Protection Plan Terms and Conditions (Includes Dispute Resolution/Arbitration Agreement and Class Action Waiver)";
      }
    }
  }

  /*Order information*/
  document.querySelector(".orderinfo .order-num").innerText = OrderNumber;

  /*Delivery information -- not handling types E and O currently */
  document.querySelector(".deliveryinfo .address-line.address1").innerText =
    Del_Address1;
  document.querySelector(".deliveryinfo .address-line.address2").innerText =
    Del_Address2;
  document.querySelector(".deliveryinfo .address-line.city").innerText =
    Del_City + ", " + Del_State + " " + Del_Zip;

  let delmsg = await process_delivery_data(orderData);
  if (delmsg != "") {
    document.querySelector(".deliveryinfo .address-line.delivery").innerHTML =
      delmsg;
  }

  /*DoorwayDelivery and Premium Shipping Upgrade*/
  if (
    DoorwayDelivery === false &&
    (deliveryType == "D" || deliveryType == "K")
  ) {
    //professional delivery applied - Brianne said not to display anything if this is the case.
    //document.querySelector('.deliveryinfo .address-line.upgrade').innerHTML='<span class="bl">Premium Delivery Applied</span>';
    //document.querySelector('.deliveryinfo .address-line.delivered2').innerText = 'Premium delivery includes delivery to any room, professional assembly and removal of packaging.';
  } else {
    if (DoorwayDelivery === true) {
      /*doorway delivery selected- already upgraded*/
      document.querySelector(
        ".deliveryinfo .address-line.delivered"
      ).innerText =
        "You have chosen Doorway Delivery and your order will be placed inside the garage or entryway of your home. Professional assembly and removal of packaging is not included";
    }
    if (upgradeDelivery === true && deliveryType != "U") {
      /*Can be upgraded*/
      let isChecked = getTotalBalance(orderData) > 0 ? false : true;
      document.querySelector(".deliveryinfo .address-line.upgrade").innerHTML =
        '<label for="upgrade"><input type="checkbox" id="upgrade" name="upgrade" ' +
        (isChecked ? "checked" : "") +
        ' /></label><span class="bl">Upgrade to Premium Delivery</span> <span class="b">- $' +
        upgradeAmount +
        "</span>";
      document.querySelector(
        ".deliveryinfo .address-line.delivered2"
      ).innerText =
        "Premium delivery includes delivery to any room, professional assembly and removal of packaging.";
    }
  }

  /*add years to year dropdown*/
  let d = new Date();
  let currentYear = d.getFullYear();
  let yearlist =
    '<option value="' +
    currentYear +
    '" selected="selected">' +
    currentYear +
    "</option>";
  for (let i = currentYear + 1; i < currentYear + 20; i++) {
    yearlist += '<option value="' + i + '">' + i + "</option>";
  }
  document.getElementById("expYear").innerHTML = yearlist;

  /*Finance section*/
  if (orderData.financePaymentEligible || orderData.financeProvider) {
    //document.querySelector(".rtgcc").classList.remove("hide");
    if(orderData?.financeProvider.length){
      if(orderData?.financeProvider?.includes('WFG'))
        document.querySelector(".options .wfgcc").classList.remove("hide");
      if(orderData?.financeProvider?.includes('GEN'))
        document.querySelector(".options .genesis-cc").classList.remove("hide");
      if(orderData?.financeProvider?.includes('SYN'))
        document.querySelector(".options .rtgcc").classList.remove("hide");
    }
    else{
      document.querySelector(".options .rtgcc").classList.remove("hide");
      document.querySelector(".options .wfgcc").classList.add("hide");
    }

    if (
      orderData.FinDeposits &&
      orderData.FinDeposits.Deposit &&
      orderData.FinDeposits.Deposit[0] &&
      orderData.FinDeposits.Deposit[0].CashCode == "RGE"
    ){
      document.querySelector(".genesis-cc").classList.add("hide");
    }
    else if(orderData?.financeProvider?.includes('WFG')) {
      document.querySelector(".genesis-cc").classList.remove("hide");
    }
  }
  document.querySelector(".pay-amount-select .other-amt").max = getTotalBalance(
    orderData,
    true
  );
  updateAmounts(orderData);
  document.querySelector(".main-section").classList.remove("hide");
  document.querySelector("section.loading").classList.add("hide");

  if (!orderData.EmailAddress || orderData.EmailAddress === "") {
    document.querySelector(".email-info").classList.remove("hide");
  } else {
    document.querySelector(".existing-email").classList.remove("hide");
    document.querySelector(".customer-email").innerHTML =
      orderData.EmailAddress;
  }
};

const clearPayPal = (orderData) => {
  ppOrderData = {};
  ppAuthAmt = 0;
  document.querySelector(".options .gift-card").classList.remove("hide");
  document.getElementById("paypal_response").value = "";
  document.querySelector(".options .tooltip.paypal").classList.add("hide");
  document.querySelector(".pp-box-success").classList.add("hide");
  document.querySelector(".review-payment .row").classList.add("hide");
  document
    .querySelector(".review-payment .line-item.paypal-applied")
    .classList.add("hide");
  document.querySelector('input[name="toc-chk"]').checked = false;
  document.querySelector('input[name="esc-chk"]').checked = false;
  document.querySelector('input[name="con-chk"]').checked = false;
  loadPayPalButton(orderData);
};

const clearApplePay = (orderData) => {
  appleOrderData = {};
  appleAuthAmt = 0;
  document.querySelector(".options .gift-card").classList.remove("hide");
  document.getElementById("apple_response").value = "";
  document.querySelector(".options .tooltip.paypal").classList.add("hide");
  document.querySelector(".apple-box-success").classList.add("hide");
  document.querySelector(".review-payment .row").classList.add("hide");
  document
    .querySelector(".review-payment .line-item.apple-applied")
    .classList.add("hide");
  document.querySelector('input[name="toc-chk"]').checked = false;
  document.querySelector('input[name="esc-chk"]').checked = false;
  document.querySelector('input[name="con-chk"]').checked = false;
  loadPayPalButton(orderData);
};

const clearCybersource = (orderData) => {
  document.querySelector(".options .tooltip.credit").classList.add("hide");
  document.querySelector(".options .gift-card").classList.remove("hide");
  ccAuthAmt = 0;
  document.querySelector(".review-payment .row").classList.add("hide");
  document
    .querySelector(".review-payment .line-item.cc-applied")
    .classList.add("hide");
  document.querySelector(".cc-box").classList.remove("hide");
  document.querySelector(".cc-box-success").classList.add("hide");
  document.querySelector("#flexresponse").value = "";
  document.querySelector("#cardNumber-container").innerHTML = "";
  document.querySelector(".col.other").classList.remove("hide");
  document.querySelector(".other-amt").disabled = false;
  document.querySelector('input[name="toc-chk"]').checked = false;
  document.querySelector('input[name="esc-chk"]').checked = false;
  document.querySelector('input[name="con-chk"]').checked = false;
  loadPayPalButton(orderData);
  loadCybersource(orderData);
};

const clearFinancing = (orderData) => { console.log('cleeear')
  financeData = {};
  financeAcctNo = "";
  availableFinBalance = 0;
  finAuthAmt = 0;
  useExistingDeposit = false;
  resetClientToken(false);
  document.querySelector(".options .gift-card").classList.remove("hide");
  document.querySelector(".long-term-plans").classList.add("hide");
  document.querySelector(".terms-conditions").classList.add("hide");
  document.querySelector(".loading-icon").classList.add("hide");
  document.querySelector(".available-balance").innerHTML = "";
  document.querySelector(".plan-name").innerHTML = "";
  document.querySelector('input[name="payments-chk"]').checked = false;
  document.querySelector('input[name="terms-chk"]').checked = false;
  document.querySelector(".options .tooltip").classList.add("hide");
  document.querySelector(".balance-applied").innerHTML = "";
  document.querySelector(".review-payment .row").classList.add("hide");
  document
    .querySelector(".review-payment .line-item.finance-applied")
    .classList.add("hide");
  document
    .querySelector(".review-payment .line-item.genesis-finance-applied")
    .classList.add("hide");
  document.querySelector("#synchronyacct").value = "";
  document.querySelector(".rtgcc-box").classList.remove("hide");
  document.querySelector(".gift-card-box").classList.add("hide");
  document.querySelector(".rtgcc-box-success").classList.add("hide");
  document.querySelector("#synchrony-btn")?.classList?.add("hide");
  document.querySelector("#synchrony-cancel-btn")?.classList?.add("hide");
  document.querySelector("#synchrony-remove-btn")?.classList?.add("hide");
  document.querySelector("#synchrony-agree-btn")?.classList?.add("hide");
  document.querySelector("#synchrony-deposit-cancel-btn").classList.add("hide");
  document.querySelector("#synchrony-deposit-agree-btn").classList.add("hide");
  document.querySelector(".promo-disclosures")?.classList.add("hide");
  document.querySelector(".promo-deposit-disclosures").classList.add("hide");
  document.querySelector(".plan-name").classList.add("hide");
  document.querySelector(".balance-check").classList.add("hide");
  document.querySelector(".col.other").classList.remove("hide");
  document.querySelector(".options .tooltip").classList.add("hide");
  document.querySelector(".other-amt").disabled = false;
  document.querySelector('input[name="toc-chk"]').checked = false;
  document.querySelector('input[name="esc-chk"]').checked = false;
  document.querySelector('input[name="con-chk"]').checked = false;

  if (orderData.financePaymentEligible) {
    if (
      orderData.FinDeposits &&
      orderData.FinDeposits.Deposit &&
      orderData.FinDeposits.Deposit[0] &&
      orderData.FinDeposits.Deposit[0].CashCode == "RGE"
    )
      document.querySelector(".genesis-cc").classList.add("hide");
    else document.querySelector(".genesis-cc").classList.remove("hide");
  }
  loadPayPalButton(orderData);
};



const clearGenesis = (orderData) => {
  genesisData = {};
  genesisAcctNo = "";
  availableGenesisBalance = 0;
  genesisAuthAmt = 0;
  document.querySelector(".options .gift-card").classList.remove("hide");
  //document.querySelector(".options .rtgcc").classList.remove("hide");
  document.querySelector(".options .tooltip").classList.add("hide");
  document.querySelector(".options .tooltip.credit").classList.add("hide");
  document.querySelector(".loading-icon").classList.add("hide");
  document.querySelector("#genesisacct").value = "";
  document.querySelector("#genesisphone").value = "";
  document.querySelector(".genesis-cc-box").classList.remove("hide");
  document.querySelector(".genesis-cc-box-success").classList.add("hide");
  document.querySelector("#genesis-btn").classList.add("hide");
  document
    .querySelector(".review-payment .line-item.genesis-finance-applied")
    .classList.add("hide");
  document.querySelector(".balance-applied").innerHTML = "";
  document.querySelector('input[name="genesis-terms-chk"]').checked = false;

  if (orderData.financePaymentEligible) {
    if(orderData?.financeProvider.length){
      if(orderData?.financeProvider?.includes('WFG'))
        document.querySelector(".options .wfgcc").classList.remove("hide");
      if(orderData?.financeProvider?.includes('GEN'))
        document.querySelector(".options .genesis-cc").classList.remove("hide");
      if(orderData?.financeProvider?.includes('SYN'))
        document.querySelector(".options .rtgcc").classList.remove("hide");
    }
    else{
      document.querySelector(".options .rtgcc").classList.remove("hide");
      document.querySelector(".options .wfgcc").classList.add("hide");
    }
  }
  loadPayPalButton(orderData);
};

const clearWellsFargo = (orderData) => {
  wfgData = {};
  wfgAcctNo = "";
  availableWfgBalance = 0;
  wfgAuthAmt = 0;
  wfgSelectedPlan = {};
  document.querySelector(".options .gift-card").classList.remove("hide");
  //document.querySelector(".options .rtgcc").classList.remove("hide");
  document.querySelector(".options .tooltip").classList.add("hide");
  document.querySelector(".options .tooltip.credit").classList.add("hide");
  document.querySelector(".loading-icon").classList.add("hide");

  document.querySelector(".genesis-cc-box").classList.add("hide");
  document.querySelector(".genesis-cc-box-success").classList.add("hide");
  document.querySelector("#genesis-btn").classList.add("hide");
  document.querySelector(".review-payment .line-item.genesis-finance-applied").classList.add("hide");
  document.querySelector(".review-payment .line-item.wfg-finance-applied").classList.add("hide");
  document.querySelector(".balance-applied").innerHTML = "";
  document.querySelector('input[name="genesis-terms-chk"]').checked = false;

  if(orderData?.financeProvider.length){
    if(orderData?.financeProvider?.includes('WFG'))
      document.querySelector(".options .wfgcc").classList.remove("hide");
    if(orderData?.financeProvider?.includes('GEN'))
      document.querySelector(".options .genesis-cc").classList.remove("hide");
    if(orderData?.financeProvider?.includes('SYN'))
      document.querySelector(".options .rtgcc").classList.remove("hide");
  }
  loadPayPalButton(orderData);
};

const clearGiftCard = (orderData) => {
  giftCardData = {};
  giftCardAcctNo = "";
  availableGiftCardBalance = 0;
  giftCardAuthAmt = 0;
  document.querySelector(".options .cc").classList.remove("hide");
  grecaptcha.reset();
  if (orderData.financePaymentEligible) {
    document.querySelector(".options .rtgcc").classList.remove("hide");
    if (
      orderData.FinDeposits &&
      orderData.FinDeposits.Deposit &&
      orderData.FinDeposits.Deposit[0] &&
      orderData.FinDeposits.Deposit[0].CashCode == "RGE"
    )
      document.querySelector(".genesis-cc").classList.add("hide");
    else
      document.querySelector(".options .genesis-cc").classList.remove("hide");
  }
  document.querySelector(".options .ppl").classList.remove("hide");
  document.querySelector(".options .tooltip").classList.add("hide");
  document.querySelector(".options .tooltip.credit").classList.add("hide");
  document.querySelector(".loading-icon").classList.add("hide");
  document.querySelector("#gift-card-acct").value = "";
  document.querySelector("#gift-card-pin").value = "";
  document.querySelector(".gift-card-box").classList.remove("hide");
  document.querySelector(".gift-card-box-success").classList.add("hide");
  document.querySelector("#gift-card-btn").classList.add("hide");
  document.querySelector("#gift-card-balance-btn").classList.remove("hide");
  document.querySelector("#gift-card-balance-btn").disabled = true;
  document
    .querySelector(".review-payment .line-item.gift-card-applied")
    .classList.add("hide");
  document.querySelector(".gift-card-box .balance-check").classList.add("hide");
  document.querySelector(".balance-applied").innerHTML = "";
  document.querySelector('input[name="genesis-terms-chk"]').checked = false;
  document.querySelector(".review-payment .row").classList.add("hide");
  loadPayPalButton(orderData);
};

const loadCybersource = async (orderData) => {
  const url = `${cyberendpoint}/v3/token`;
  let storeOrder = onlineStores.includes(orderData?.StoreNumber?.toString())
    ? false
    : true;
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      // 'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: JSON.stringify({ storeOrder }),
  });
  let tokenobj = await response.json();

  if (tokenobj) {
    const submitCardBtn = document.querySelector("#submit-card-btn");

    const captureContext = tokenobj;

    const myStyles = {
      input: {
        "font-size": "14px",
        color: "#555",
      },
      ":disabled": { cursor: "not-allowed" },
      valid: { color: "#3c763d" },
      invalid: { color: "#a94442" },
    };

    const flex = new window.Flex(captureContext);
    const microformInstance = flex.microform({ styles: myStyles });
    if (microformInstance._microformId) {
      const number = microformInstance.createField("number", {
        placeholder: "Enter card number",
      });
      const securityCode = microformInstance.createField("securityCode", {
        placeholder: "•••",
      });
      let dt = new Date();
      document.querySelector('#expMonth').value = `0${dt.getMonth()}`.slice(-2);
      let cardInfo = {};
      let cardData = {}

      number.on("change", (data) => {
        cardData = data;
        if (data.valid) {
          cardInfo = {
            cardName: data.card[0].name,
            cardType: data.card[0].cybsCardType,
          };
        }
      });
      number.load("#cardNumber-container");
      securityCode.load("#securityCode-container");

      submitCardBtn.addEventListener("click", () =>
        onSubmitCard(microformInstance, cardInfo, orderData, cardData)
      );
      /*submitCardBtn.addEventListener(
                'keydown',
                e => e.keyCode === 13 && onSubmitCard(microformInstance, cardInfo, orderData),
              )*/
      setTimeout(
        () => this.onError("Your session timed out. Please "),
        900000
      ); /* Token will timeout after 15 mins */
    } else {
      this.onError(
        "Something went wrong. Please ",
        "microform creation",
        "Could not create microform with provided token"
      );
    }
  } else {
    this.onError(
      "Something went wrong. Please ",
      "microform token",
      "No microform token provided"
    );
  }
};

const onSubmitCard = (microformInstance, cardInfo, orderData, cardData) => {
  const cardExpirationMonth = document.querySelector("#expMonth");
  const cardExpirationYear = document.querySelector("#expYear");
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth() + 1;

  console.log(cardData)
  const options = {
    expirationMonth: cardExpirationMonth.value,
    expirationYear: cardExpirationYear.value,
  };

  document.querySelector(".cc-errors").innerHTML = "";
  document.querySelector("section.review-payment .errors").innerHTML = "";

  if(!cardData.valid) {
    document
      .querySelector(".cc-errors")
      .insertAdjacentHTML(
        "afterbegin",
        `<p class="">Please input valid card information.</p>`
      );
    return false;
  }



  if (
    document.querySelector('input[name="pay-amount"]:checked').value ==
      "other" &&
    (parseFloat(getTotalBalance(orderData)) < 20 ||
      parseFloat(
        document.querySelector('input[name="other-amt"]').value < 20
      ) ||
      document.querySelector('input[name="other-amt"]').value == "")
  ) {
    document
      .querySelector(".cc-errors")
      .insertAdjacentHTML(
        "afterbegin",
        `<p class="">Minimum partial payment is $20</p>`
      );
    return false;
  }

  const invalidExpDate =
    Number(options.expirationYear) === currentYear &&
    Number(options.expirationMonth) < currentMonth;

  if(invalidExpDate){
    document.querySelector(".cc-errors").insertAdjacentHTML("afterbegin", `<p class="">Please enter a valid expiration date.</p>`);
    return false;
  }

  microformInstance.createToken(options, (err, mfResponse) => {
    if (err || invalidExpDate) {
      document.querySelector(".cc-errors").insertAdjacentHTML("afterbegin", `<p class="">${err?.message}</p>`);
      return;
    }
    const creditCardPaymentInfo = {
      paymentType: "CYBERV3",
      paymentProperties: {
        token: mfResponse,
        card: cardInfo,
      },
    };

    //const paymentTypesToClear = ['AFF', 'VISA', 'PALV2', 'CYBERV3']
    //const paymentInfo = orderData.paymentInfo.filter(payment => !paymentTypesToClear.includes(payment.paymentType))
    //paymentInfo.push(creditCardPaymentInfo)

    ccPaymentInfo = creditCardPaymentInfo;
    document.getElementById("flexresponse").value = mfResponse;
    //availableFinBalance =  (typeof(availableFinBalance)=='undefined') ? 0 : availableFinBalance;
    //availableGenesisBalance =  (typeof(availableGenesisBalance)=='undefined') ? 0 : availableGenesisBalance;
    //hide gift card option
    document.querySelector(".options .gift-card").classList.add("hide");
    if (longTermFinanceAmt && (selectedPlan.downPaymentRequired || wfgSelectedPlan.downPaymentRequired)) {
      document.querySelector(
        ".review-payment .line-item.cc-applied .amt"
      ).innerText = "$" + parseFloat(downPaymentAmt).toFixed(2);
    } else if (
      financeData.availableCredit < getTotalBalance(orderData) &&
      !selectedPlan.downPaymentRequired && !wfgSelectedPlan.downPaymentRequired
    ) {

      let remainingBalance = getTotalBalance(orderData) - ((typeof(availableFinBalance)=='undefined') ? 0 : availableFinBalance);
      document.querySelector(
        ".review-payment .line-item.cc-applied .amt"
      ).innerText = "$" + parseFloat(remainingBalance).toFixed(2);
    } else if (
      digiBuyState.currentTotal < getTotalBalance(orderData) && digiBuyState.currentTotal > 0 &&
      !selectedPlan.downPaymentRequired
    ) {

      let remainingBalance = getTotalBalance(orderData) - parseFloat(digiBuyState.currentTotal) - parseFloat(wfgFinAuthAmt);
      document.querySelector(
        ".review-payment .line-item.cc-applied .amt"
      ).innerText = "$" + parseFloat(remainingBalance).toFixed(2);
    }
     else {

      availableFinBalance = ((typeof(availableFinBalance)=='undefined') ? 0 : availableFinBalance);


      document.querySelector(
        ".review-payment .line-item.cc-applied .amt"
      ).innerText =
        "$" +
        parseFloat(
          getTotalBalance(orderData) -
            parseFloat(availableFinBalance) -
            parseFloat(availableGenesisBalance) -
            parseFloat(giftCardAuthAmt) -
            parseFloat(digiBuyState?.currentTotal) -
            parseFloat(wfgFinAuthAmt)
        ).toFixed(2);

    }

    document
      .querySelector(".review-payment .line-item.cc-applied")
      .classList.remove("hide");

    document.querySelector(".other-amt").disabled = true;
    document
      .querySelector(".review-payment .row")
      .classList.remove("hide"); /*makes step 4 visible*/
    scrollToReview();
    document.querySelector(".cc-box-success").classList.remove("hide");
    document.querySelector(".cc-box").classList.add("hide");
    loadPayPalButton(orderData);

  });
};

const onError = (
  errorMessage,
  errorTitle = null,
  errorDescription = null,
  errorData = null,
  level = levels.info
) => {
  console.log(`${errorMessage}:${error}`);
};

const removeCC = () => {
  document.querySelector(".cc-box").classList.add("hide");
};

const pay_toggle = async (x) => {
  /*toggles visible payment option*/
  //document.querySelector('.balance-applied').innerHTML = '';
  document.querySelector(".cc-box-success").classList.add("hide");
  document.querySelector(".rtgcc-box-success").classList.add("hide");
  document.querySelector(".genesis-cc-box-success").classList.add("hide");
  document.querySelector(".gift-card-box-success").classList.add("hide");
  document.querySelector(".options .cc").classList.add("off");
  document.querySelector(".options .rtgcc").classList.add("off");
  document.querySelector(".options .wfgcc").classList.add("off");
  document.querySelector(".options .genesis-cc").classList.add("off");
  document.querySelector(".options .gift-card").classList.add("off");

  document.querySelector(".cc-box").classList.add("hide");
  document.querySelector(".rtgcc-box").classList.add("hide");
  document.querySelector(".genesis-cc-box").classList.add("hide");
  document.querySelector(".gift-card-box").classList.add("hide");

  document.querySelector(".options ." + x).classList.remove("off");
  document.querySelector("." + x + "-box")?.classList?.remove("hide");

};

const process_delivery_data = async (orderData) => {
  /*generate display message for delivery info*/

  /*Delivery Types
	D - Adult Delivery
	K - Kids Delivery
	C - Corporate Delivery
	X - Exports Delivery
	Z - Store Pickup
	U - UPS Delivery
	O - Vendor Delivery
	T - GiftCards
	E - Expresss Delivery
	P - Warehouse Pickup
	*/

  /*delivery data*/
  let I95ind = orderData.I95ind;
  let DeliveryDate = orderData.DeliveryDate;
  let deliveryType = orderData.DeliveryType;
  let StoreNumber = orderData.StoreNumber;
  let EstimatedDeliveryTimeFrame = orderData.EstimatedDeliveryTimeFrame;
  const ableToReschedule = orderData.AbleToReschedule || false;

  let isweb = false;
  if (onlineStores.includes(StoreNumber?.toString())) {
    isweb = true;
  }

  if (
    !["D", "K", "C", "X", "Z", "U", "O", "T", "E", "P"].includes(deliveryType)
  ) {
    /*if no custom logic, pretends it's D*/
    deliveryType = "D";
  }

  let delmsg = "";
  if (
    !DeliveryDate ||
    DeliveryDate == "" ||
    DeliveryDate.substring(0, 4) == "0001"
  ) {
    delmsg =
      "<strong>Estimated Delivery Notes</strong> Contact Customer Service to Schedule a Delivery Date - (800)766-6786";
  } else {
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const weekdays = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    let tmpdate = new Date(DeliveryDate.replace("Z", ""));
    let delts = Date.parse(DeliveryDate);
    let curts = Date.now();
    let diffts = (delts - curts) / 1000;
    let theDeliveryDate =
      weekdays[tmpdate.getDay()] +
      ", " +
      months[tmpdate.getMonth()] +
      " " +
      tmpdate.getDate() +
      ", " +
      tmpdate.getFullYear();

    if (["D", "K", "C", "X"].includes(deliveryType)) {
      if (I95ind === true) {
        delmsg = "<strong>Date scheduled to leave warehouse</strong>";
        if (diffts < 48 * 3600) {
          if (diffts < 0 && EstimatedDeliveryTimeFrame == "") {
            delmsg += "Has left the warehouse.";
          } else {
            delmsg += EstimatedDeliveryTimeFrame;
            //delmsg+="Should Arrive within "+(Math.ceil(diffts/3600)).toFixed(2)+" hours.";
          }
        } else {
          delmsg +=
            "Specific time frame information is not yet available.<br>Please check back in 48 hours prior to your 4 hour delivery window.";
        }
      } else {
        delmsg =
          "<strong>Scheduled Delivery Date</strong><span>" +
          theDeliveryDate +
          "</span>";
        if (diffts < 48 * 3600) {
          if (diffts < 0 && EstimatedDeliveryTimeFrame == "") {
            delmsg += "Delivered on " + theDeliveryDate;
          } else {
            delmsg += EstimatedDeliveryTimeFrame;
            //delmsg+="Should Arrive within "+(Math.ceil(diffts/3600)).toFixed(2)+" hours.";
          }
        } else {
          delmsg +=
            "Specific time frame information is not yet available.<br>Please check back in 48 hours prior to your 4 hour delivery window.";
        }
        show_reschedule_delivery(ableToReschedule,orderData.orderKey);
      }
    }
    if (deliveryType == "Z") {
      delmsg =
        "<strong>Store Arrival Date</strong> " +
        theDeliveryDate +
        "<br>" +
        '<div class="address-line"><strong>' +
        orderData.PickUpData.StoreName +
        "</strong></div>" +
        '<div class="address-line">' +
        orderData.PickUpData.PickupAddress.Address1 +
        "</div>" +
        (orderData.PickUpData.PickupAddress.Address2
          ? '<div class="address-line">' +
            orderData.PickUpData.PickupAddress.Address2 +
            "</div>"
          : "") +
        '<div class="address-line">' +
        orderData.PickUpData.PickupAddress.City +
        " " +
        orderData.PickUpData.PickupAddress.State +
        ", " +
        orderData.PickUpData.PickupAddress.Zip +
        "</div>" +
        '<div class="address-line">Phone: ' +
        orderData.PickUpData.Phone +
        "</div>";
    }
    if (deliveryType == "P") {
      delmsg =
        "<strong>Scheduled Pickup Date</strong> " +
        theDeliveryDate +
        "<br>" +
        '<div class="address-line"><strong>' +
        orderData.PickUpData.StoreName +
        "</strong></div>" +
        '<div class="address-line">' +
        orderData.PickUpData.PickupAddress.Address1 +
        "</div>" +
        (orderData.PickUpData.PickupAddress.Address2
          ? '<div class="address-line">' +
            orderData.PickUpData.PickupAddress.Address2 +
            "</div>"
          : "") +
        '<div class="address-line">' +
        orderData.PickUpData.PickupAddress.City +
        " " +
        orderData.PickUpData.PickupAddress.State +
        ", " +
        orderData.PickUpData.PickupAddress.Zip +
        "</div>" +
        '<div class="address-line">Phone: ' +
        orderData.PickUpData.Phone +
        "</div>" +
        '<div class="address-line">Time: ' +
        orderData.PickUpData.PickupHours.string[tmpdate.getDay()] +
        "</div>";
        if(ableToReschedule){
          document.getElementById("reschedule-btn").classList.remove("hide");
          document.getElementById("reschedule-btn").innerHTML = `<div class="reschedule-delivery"><a href="/delivery/index.html?orderKey=${orderData.orderKey}" style="color: inherit;   text-decoration: none;  cursor: default;">Reschedule your pick up date</a></div>`;
        }
    }
    if (deliveryType == "U") {
      if (isweb) {
        delmsg =
          "<strong>Estimated Delivery Notes</strong> Please check your Order confirmation email for the delivery estimates or call Customer Service at (800)766-6786";
      } else {
        delmsg = "<strong>Estimated Delivery Date</strong> " + theDeliveryDate;
      }
    }
    if (deliveryType == "O") {
      if (isweb) {
        delmsg = "<strong>Ships Direct from Vendor</strong>"; // Estimated delivery date: "+theDeliveryDate;
      } else {
        delmsg = "<strong>Ships Direct from Vendor</strong>";
      }
    }
    if (deliveryType == "T") {
      if (isweb) {
        delmsg =
          "<strong>Estimated Delivery Notes</strong> Mailed to Billing Address via USPS";
      } else {
        delmsg =
          "<strong>Estimated Delivery Notes</strong> Contact Showroom for Pickup Date: " +
          orderData.PickUpData.StoreName;
      }
    }

    if (deliveryType == "E") {
      delmsg =
        "<strong>Scheduled Delivery Date</strong><span>" +
        theDeliveryDate +
        "</span>";
      if (diffts < 48 * 3600) {
        if (diffts < 0 && EstimatedDeliveryTimeFrame == "") {
          delmsg += "Delivered on " + theDeliveryDate;
        } else {
          delmsg += EstimatedDeliveryTimeFrame;
          //delmsg+="Should Arrive within "+(Math.ceil(diffts/3600)).toFixed(2)+" hours.";
        }
      } else {
        delmsg =
          "<strong>Estimated Delivery Notes</strong> Your delivery has an all day delivery window (7a - 10p). We are unable to establish a specific delivery window because Express Delivery requires such a quick turnaround.";
      }
      show_reschedule_delivery(ableToReschedule,orderData.orderKey);
    }
  }

  return delmsg;
};

const show_reschedule_delivery = async (ableToReschedule,orderKey) => {
  const reschedulingHtml = `<a href="/delivery/index.html?orderKey=${orderKey}" style="color: inherit;   text-decoration: none;  cursor: default;">Reschedule your delivery date</a>`;
    if(ableToReschedule){
      document.getElementById("reschedule-btn").classList.remove("hide");
      document.getElementById("reschedule-btn").innerHTML = reschedulingHtml;
    }
}

const show_thank_you = async (orderKey, orderId, zipcode, curpay, order) => {
  /*thank you display*/
  document.querySelector(".container .main-section").classList.add("hide");
  let billingAddress = order.BillingAddress;
  let action = "/ordersHistoryByKey";
  let orderRes = await fetch(`${endpoint}${action}?orderKey=${orderKey}`);
  let orderData = await orderRes.json();

  let lineitems = "";
  if (orderData.LineItems && orderData.LineItems.LineItem.length > 0) {
    let prods = [];
    for (let i = 0; i < orderData.LineItems.LineItem.length; i++) {
      let item = orderData.LineItems.LineItem[i];
      if(parseInt(item?.Quantity) > 0){
      lineitems +=
        '<div class="items"><div class="name">' +
        (item.DisplayName ? item.DisplayName : item?.VendorDescription) +
        '</div><div class="qty">QTY: ' +
        item.Quantity +
        "</div></div>";
      }
      prods.push({
        sku: item.Sku,
        name: (item.DisplayName ? item.DisplayName : item?.VendorDescription),
        ...item
      });
    }

  }

  if (!orderData.EmailAddress || orderData.EmailAddress == "") {
    orderData.EmailAddress = document.getElementById("email_addr").value;
  }

  document.querySelector(".box .line-items").innerHTML = lineitems;

  let delmsg = await process_delivery_data(orderData);
  if (delmsg != "") {
    document.querySelector(
      "section.thank-you .address-line.delivery"
    ).innerHTML = delmsg;
  }

  document
    .querySelector(".thankreturn")
    .setAttribute("href", redirurl + `?orderKey=${order.orderKey}`);

  /*delivery data*/
  let Del_Address1 = orderData.DeliveryAddress.Address1.toLowerCase();
  let Del_Address2 = orderData.DeliveryAddress.Address2.toLowerCase();
  let Del_City = orderData.DeliveryAddress.City.toLowerCase();
  let Del_State = orderData.DeliveryAddress.State;
  let Del_Zip = orderData.DeliveryAddress.Zip;
  let Del_Email = orderData.EmailAddress;
  let Customer =
    orderData.Customer.FirstName + " " + orderData.Customer.LastName;
  let Bill_Address1 = billingAddress.Address1.toLowerCase();
  let Bill_Address2 = billingAddress.Address2.toLowerCase();
  let Bill_City = billingAddress.City.toLowerCase();
  let Bill_State = billingAddress.State;
  let Bill_Zip = billingAddress.Zip;

  /*Delivery information -- not handling types E and O currently */
  document.querySelector("section.thank-you .address-line.customer").innerText =
    Customer.toLowerCase();
  document.querySelector("section.thank-you .address-line.address1").innerText =
    Del_Address1;
  document.querySelector("section.thank-you .address-line.address2").innerText =
    Del_Address2;
  document.querySelector("section.thank-you .address-line.city").innerText =
    Del_City + ", " + Del_State + " " + Del_Zip;
  document.querySelector("section.thank-you .address-line.email").innerText =
    Del_Email;
  document.querySelector("section.thank-you .t .em").innerText = Del_Email;

  document.querySelector(
    "section.thank-you .billing .address-line.customer"
  ).innerText = Customer.toLowerCase();
  document.querySelector(
    "section.thank-you .billing .address-line.address1"
  ).innerText = Bill_Address1;
  document.querySelector(
    "section.thank-you .billing .address-line.address2"
  ).innerText = Bill_Address2;
  document.querySelector(
    "section.thank-you .billing .address-line.city"
  ).innerText = Bill_City + ", " + Bill_State + " " + Bill_Zip;
  document.querySelector(
    "section.thank-you .billing .address-line.payment"
  ).innerHTML = `${
    ccAuthAmt > 0
      ? `Credit Card <br/> $${parseFloat(ccAuthAmt).toFixed(2)}<br/>`
      : ``
  } ${
    finAuthAmt > 0
      ? `Financing <br/>$${
          longTermFinanceAmt > 0
            ? longTermFinanceAmt
            : parseFloat(finAuthAmt).toFixed(2)
        }<br/>`
      : ``
  } ${
    giftCardAuthAmt > 0
      ? `Gift Card <br/>$${parseFloat(giftCardAuthAmt).toFixed(2)}<br/>`
      : ``
  } ${
    genesisAuthAmt > 0
      ? `Concora Financing <br/>$${parseFloat(genesisAuthAmt).toFixed(2)}<br/>`
      : ``
  } ${
    ppAuthAmt > 0 && ppOrderData.orderID
      ? `PayPal <br/> $${parseFloat(ppAuthAmt).toFixed(2)}<br/>`
      : ``
  } ${
    parseFloat(appleAuthAmt) > 0 && appleOrderData.paymentData
      ? `Apple Pay <br/> $${parseFloat(appleAuthAmt).toFixed(2)}<br/>`
      : ``
  }`;
  /*totals*/
  let ordertotal = parseFloat(orderData.OrderTotal);
  let subtotal = orderData.subTotal.toFixed(2);
  let shipdel = orderData.DeliveryCharge || 0;
  let salestax = orderData.TaxAmount;
  let balance = orderData.Balance || 0;
  let prevpay = parseFloat(ordertotal - parseFloat(balance) - curpay).toFixed(2);

  let totals = "";
  if (subtotal != "") {
    totals +=
      '<div class="label">Sub-Total</div><div class="amount sub">$' +
      subtotal +
      "</div>";
  }
  if (shipdel != "") {
    totals +=
      '<div class="label">Shipping & Delivery</div><div class="amount">$' +
      parseFloat(shipdel).toFixed(2) +
      "</div>";
  }
  if (salestax != "") {
    totals +=
      '<div class="label">Sales Tax</div><div class="amount">$' +
      salestax +
      "</div>";
  }
  if (prevpay != "") {
    totals +=
      '<div class="label">Previous Payments</div><div class="amount">$' +
      prevpay +
      "</div>";
  }
  if (curpay != "") {
    totals +=
      '<div class="label current">Current Payment</div><div class="amount current">$' +
      parseFloat(curpay).toFixed(2) +
      "</div>";
  }
  if (balance != "" && !mattressUpsell) {
    totals +=
      '<div class="label balance">Remaining Total</div><div class="amount balance">$' +
      balance +
      "</div>";
  }
  document.querySelector("section.thank-you .blocks .totals").innerHTML =
    totals;

  document.querySelector("section.thank-you").classList.remove("hide");
  document.querySelector("section.loading").classList.add("hide");
};

function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function setCookie(name,value,days) {
  var expires = "";
  if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days*24*60*60*1000));
      expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

function eraseCookie(c_name) {
  setCookie(c_name,"",-1);
}
